export default {
	Active: "Activo",
	Inactive: "Inactivo",
	RequiredField: "Campo requerido",
	Close: "Cerrar",
	Copy: "Copiar",
	Copied: "Copiado",
	CopiedToClipboard: "Copiado al portapapeles",
	CopiedError: "Error al copiar",
	Duplicate: "Duplicar",
	With: "con",
	Date: "Fecha",
	Hour: "Hora",
	And: " y ",
	All: "Todos",
	Recent: "Recientes",
	Check: "Verificar",
	ServiRoutes: "ServiRoutes",
	Clear: "Limpiar",
	Filters: "Filtros",
	Go: "Ir",
	Ago: "Hace",
	To: "para",
	Next: "Siguiente",
	Previous: "Anterior",
	Information: "Informaci\u00F3n",
	Options: "Opciones",
	Selection: "Selecci\u00F3n",
	Serviform: "Serviforms",
	Serviroute: "Serviroute",
	ServiApps: "Servi Aplicaciones",
	Username: "Nombre de Usuario",
	Lastname: "Apellidos",
	Email: "Correo electrónico",
	Role: "Rol",
	Status: "Estado",
	Type: "Tipo",
	New: "Nuevo",
	Help: "Ayuda",
	Replace: "Reemplazar",
	Name: "Nombre",
	Days: "D\u00EDas",
	Locate: "Localizar",
	ErrorTitle: "Ocurrio un error",
	ErrorMessage: "Ocurrio un error. Porfavor intentelo de nuevo!",
	Enter: "Ingrese",
	ContactPerson: "Contacto Personal",
	Country: "Pa\u00EDs",
	City: "Ciudad",
	Department: "Departamento",
	Province: "Provincia",
	Region: "Región",
	State: "Estado",
	Canton: "Cantón",
	Municipality: "Municipio",
	District: "Distrito",
	Commune: "Comuna",
	Description: "Descripci\u00F3n",
	InitDate: "Fecha Inicial",
	EndDate: "Fecha Final",
	InitHour: "Hora Inicial",
	EndHour: "Hora Final",
	Address: "Direcci\u00F3n",
	Identification: "Identificaci\u00F3n",
	Phone: "Tel\u00E9fono",
	Submit: "Enviar",
	Accept: "Aceptar",
	Cancel: "Cancelar",
	Reset: "Reiniciar",
	Action: "Acci\u00F3n",
	Actions: "Acciones",
	AddNew: "Agregar Nuevo",
	AddNew2: "Agregar Nueva",
	Add: "Agregar",
	Start: "Inicio",
	End: "Fin",
	Startandend: "Inicio y Fin",
	Update: "Actualizar",
	Dashboard: "Panel de control",
	eCommerce: "Comercio electrónico",
	Apps: "Aplicaciones",
	Todo: "Todo",
	Calendar: "Calendario",
	FullCalendar: "Calendario completo",
	SimpleCalendar: "Calendario sencillo",
	Shop: "Compras",
	ItemDetails: "Detalles de productos",
	Cart: "Carrito",
	WishList: "Lista de deseos",
	Checkout: "Pagos",
	UI: "UI",
	DataList: "Lista de datos",
	ListView: "Vista de la lista",
	ThumbView: "Vista de pulgar",
	Grid: "Cuadrícula",
	Vuexy: "Vuexy",
	Vuesax: "Vuesax",
	Tailwind: "Tailwind",
	Colors: "Colores",
	Card: "Tarjeta",
	Basic: "Básico",
	Analytics: "Analitica",
	CardActions: "Acciones de tarjeta",
	CardColors: "Colores de la tarjeta",
	Table: "Tabla",
	agGridTable: "agGrid Table",
	Components: "Componentes",
	Alert: "Alertas",
	Avatar: "Avatar",
	Badge: "Badge",
	Breadcrumb: "Breadcrumb",
	Button: "Botones",
	ButtonGroup: "Grupos de Botones",
	Chip: "Chip",
	Collapse: "Colapso",
	Dialogs: "Dialogos",
	Divider: "Divisor",
	DropDown: "Desplegable",
	List: "Lista",
	Loading: "Cargando",
	Navbar: "Barra de navegación",
	Notifications: "Notificaciones",
	Pagination: "Paginación",
	Popup: "Popup",
	Progress: "Progreso",
	Sidebar: "Barra lateral",
	Slider: "Deslizador",
	Tabs: "Pestañas",
	Tooltip: "Tooltip",
	Upload: "Cargar",
	Manage: "Administrar",
	FormsAndTable: "Formularios y tabla",
	FormElements: "Elementos de formulario",
	Select: "Seleccionar",
	SelectAll: "Seleccionar Todos",
	Deselect: "Deseleccionar Todos",
	Switch: "Switch",
	Checkbox: "Checkbox",
	Required: "Requerido",
	Radio: "Radio",
	Input: "Input",
	NumberInput: "Entrada de número",
	Textarea: "Textarea",
	FormLayouts: "Form Layouts",
	FormWizard: "Form Wizard",
	FormValidation: "Form Validation",
	FormInputGroup: "Form Input Group",
	Pages: "Página",
	Authentication: "Autenticación",
	Register: "Registro",
	ForgotPassword: "Has olvidado tu contraseña",
	LockScreen: "Bloquear pantalla",
	Miscellaneous: "Miscellaneous",
	ComingSoon: "Muy pronto",
	Error: "Error",
	404: "404",
	500: "500",
	NotAuthorized: "No autorizado",
	Maintenance: "Mantenimiento",
	Profile: "Perfil",
	Logout: "Cerrar Sesi\u00F3n",
	User: "Usuarios",
	View: "Ver",
	Edit: "Editar",
	UserSettings: "Ajustes de usuario",
	CompanySettings: "Configuración de Empresas",
	Invoice: "Facturas",
	FAQ: "FAQ",
	Search: "Buscar",
	SearchBy: "Busqueda por",
	SearchOn: "Buscar en",
	CurrentPage: "Página actual",
	AllPages: "Todas las página",
	KnowledgeBase: "Base de conocimientos",
	ChartsAndMaps: "Gráficos y mapas",
	Charts: "Gráficos",
	ApexCharts: "Apex Charts",
	chartjs: "chartjs",
	echarts: "echarts",
	chartist: "chartist",
	GoogleMap: "Google Map",
	Extensions: "Extensiones",
	QuillEditor: "Editora de plumas",
	DragAndDrop: "Arrastrar y soltar",
	Datepicker: "Selector de fechas",
	DatetimePicker: "Selector de fecha y hora",
	AccessControl: "Control de acceso",
	I18n: "I18n",
	Carousel: "Carrusel",
	Clipboard: "Clipboard",
	ContextMenu: "Context Menu",
	StarRatings: "Star Ratings",
	Autocomplete: "Autocomplete",
	Tree: "Tree",
	Import: "Import",
	Export: "Exportar",
	Selected: "Seleccionado",
	ExportSelected: "Exportar Selección",
	ExportAll: "Exportar Todo",
	CellAutoWidth: "Ancho automático de celda",
	EnterFileName: "Ingrese Nombre del Archivo",
	Others: "Otros",
	MenuLevels: "Niveles de menú",
	MenuLevel2p1: "Nivel de menú 2.1",
	MenuLevel2p2: "Nivel de menú 2.2",
	MenuLevel3p1: "Nivel de menú 3.1",
	MenuLevel3p2: "Nivel de menú 3.2",
	DisabledMenu: "Menú deshabilitado",
	Support: "Soporte",
	Documentation: "Documentacion",
	RaiseSupport: "Levantar apoyo",
	demoTitle: "Título de la tarjeta",
	demoText:
		"Pastel de brochetas de sésamo cupcake pan de jengibre danés Me encanta el pan de jengibre. Apple pie pie jujubes chupa chups muffin halvah lollipop. Tarta de chocolate bizcocho de avena tiramisú mazapán azúcar ciruela. Donut pastel dulce pastel de avena gragea pastel de frutas algodón de azúcar gotas de limón.",
	ExportToExcel: "Exportar a Excel",
	Map: "Mapa",
	Programed: "PROGRAMADA",
	Executed: "EJECUTADA",
	Both: "AMBAS",
	Company: "Empresa",
	NewCompany: "Nueva Empresa",
	UpdateCompany: "Actualizar Empresa",
	ListOfCompanies: "Lista de Empresas",
	TitleConfirmCompanyCreate: "Empresa creada",
	TextConfirmCompanyCreate: "La empresa fue creada exitosamente",
	TitleConfirmCompanyDelete: "Empresa Eliminada",
	TextConfirmCompanyDelete: "La empresa seleccionada fue eliminada exitosamente",
	TitleConfirmCompanyUpdate: "Empresa Actualizada",
	TextConfirmCompanyUpdate: "La empresa seleccionada fue actualizada exitosamente",
	DeleteCompany: "¿Estas seguro de eliminar la empresa? Por favor aceptar para continuar.",
	Confirm: "Confirmar",
	MissingFieldTitle: "Campos faltantes",
	MissingField: "Faltan algunos campos en el formulario",
	CompanyName: "Nombre de la Empresa",
	CompanyFormTitleCreate: "Formulario para crear una nueva empresa",
	CompanyFormTitleUpdate: "Formulario para actualizar una empresa",
	CompanyConfigCrud: "Configuración de la empresa",
	CompanyAddNewField: "Agrear un campo adicional",
	CompanyConfigCrudFormTitleCreate: "Formulario para crear una configuración de empresa",
	CompanyConfigCrudFormTitleEdit: "Formulario para editar una configuración de empresa",
	CompanyConfigCrudFormTitle: "Formulario para crear una configuración de empresa",
	CompanyConfNameAddLabel: "Nombre del campo",
	CompanyConfValueAddLabel: "Valor",
	CompanyConfNameAddValidMessage: "Solo caracteres alfabéticos, sin espacios",
	CompanyConfValueAddValidMessage: "Por favor ingresar valor",
	DeleteCompanyConf: "¿Esta seguro de eliminar la configuración de empresa?",
	TitleConfirmCompanyConfigDelete: "Configuración de Empresa Eliminada",
	TextConfirmCompanyConfigDelete: "La configuración seleccionada fue eliminada exitosamente",
	TitleConfirmCompanyConfigCreate: "Empresa de configuración creada",
	TextConfirmCompanyConfigCreate: "La configuración se creó con éxito",
	TitleConfirmCompanyConfigUpdate: "Empresa de configuración actualizada",
	TextConfirmCompanyConfigUpdate: "La configuración seleccionada se actualizó correctamente",
	NewCompanyConfig: "Nueva configuración de Empresa",
	UpdateCompanyConfig: "Actualizar Configuración de Empresa",
	ListOfCompaniesConfig: "Lista de Configuraciones de Empresa",
	TitleWarningExistPropertyCompanyConfig: "Ya existe",
	TextWarningExistPropertyCompanyConfig: "El valor a ingresar ya se encuentra",
	UpdateCompanyConfigErrorMessage: "Ocurrio un error actualizando la configuración",
	IvalidValuesErrorMessage: "valores inválidos",
	TypeConfig: "Tipo de configuración",
	NewTypeConfig: "Nuevo Tipo de Configuración",
	NewTypeConfigRequired: "Tipo de Configuración Requerida",
	UpdateTypeConfig: "Actualizar Tipo de Configuración",
	ListOfTypeConfig: "Lista de Tipos de Configuración",
	InputNameTypeConfig: "Nombre del tipo",
	ButtonAddTypeConfig: "Añadir",
	TitleConfirmTypeConfigUpdate: "Tipo de configuración modificada",
	TextConfirmTypeConfigUpdate: "El tipo de configuración seleccionada fue modificada exitosamente",
	TypeConfigCrudFormTitleCreate: "Formulario para crear un tipo de configuración",
	TypeConfigCrudFormTitleEdit: "Formulario para editar un tipo de configuración",
	TitleSuccessTypeConfigCreated: "Tipo Configuración creada",
	TextSuccessTypeConfigCreated: "El tipo de configuración se creó correctamente",
	TitleSuccessTypeConfigCreatedError: "Error al crear el tipo de configuración",
	TextSuccessTypeConfigCreatedError: "El tipo de configuración no ha sido creado",
	DeleteTypeConf: "¿Está seguro de eliminar este tipo de configuración?",
	TypeConfigConfigName: "Nombre Tipo de Configuración",
	TypeConfigStatus: "Estado",
	TypeConfigAddDateOn: "Añadido",
	Tipology: "Tipolog\u00EDa",
	TextConfirmTipologyCreate: "La tipolog\u00EDa fue creada exitosamente",
	TextConfirmTipologyUpdate: "La tipolog\u00EDa fue modificada exitosamente",
	TextConfirmTipologyDelete: "La tipolog\u00EDa fue eliminada exitosamente",
	TitleConfirmTipologyCreate: "Tipolog\u00EDa Creada",
	TitleConfirmTipologyUpdate: "Tipolog\u00EDa Actualizada",
	TitleConfirmTipologyDelete: "Tipolog\u00EDa Eliminada",
	TextDeleteTipology: "¿Estas seguro de eliminar la tipolog\u00EDa",
	TextAccepContinue: "Por favor aceptar para continuar.",
	Save: "Guardar",
	Remove: "Quitar",
	Category: "Categor\u00EDa",
	NewCategory: "Nueva Categor\u00EDa",
	ListOfCategories: "Lista de Categor\u00EDas",
	TitleConfirmCategoryCreate: "Objeto Creado",
	TitleConfirmCategoryUpdate: "Objeto Actualizado",
	TitleConfirmCategoryDelete: "Objeto Eliminado",
	TextConfirmCategoryCreate: "El nuevo objeto fue creado con éxito",
	TextConfirmCategoryUpdate: "El objeto fue actualizado con éxito",
	TextConfirmCategoryDelete: "El objeto fue eliminada con éxito",
	Resources: "Recursos",
	CreateResource: "Crear Recurso",
	CreateObject: "Crear Objeto",
	ResourceList: "Lista de Recursos",
	ResourceView: "Ver Recurso",
	Objects: "Objetos",
	ObjectType: "Tipo de Objeto",
	NewObject: "Nuevo Objeto",
	ListOfObjects: "Lista de objetos",
	TooltipSchemas: `El esquema define las propiedades mínimas que pueden tener los objetos dependiendo del tipo seleccionado.`,
	Config: "Configuraci\u00F3n",
	VisitPoint: "Punto de Visita",
	VisitPoints: "Puntos de Visita",
	CreateVisitPoint: "Crear Punto de Visita",
	UpdateVisitPoint: "Editar Punto de Visita",
	ListVisitPoint: "Lista Puntos de Visita ",
	MassiveDelete: "Eliminaci\u00F3n Masiva",
	ActivityList: "Lista de Actividades",
	TitleConfirmActivityCreate: "Actividad creada",
	TextConfirmActivityCreate: "La actividad fue creada exitosamente",
	TitleConfirmActivityDelete: "Actividad Eliminada",
	TextConfirmActivityDelete: "La actividad seleccionada fue eliminada exitosamente",
	TitleConfirmActivityUpdate: "Actividad Actualizada",
	TextConfirmActivityUpdate: "La actividad seleccionada fue actualizada exitosamente",
	DeleteActivity:
		"Al eliminar una actividad tenga en cuenta que se eliminaran también todas la vistas asociadas y las que están siendo gestionadas con esta actividad. La actividad seleccionada es",
	DeleteActivityConfirm:
		"Por favor, escribe el nombre de la actividad en el siguiente cuadro de texto para continuar la eliminación",
	UpdateActivity: "Actualizar Actividad",
	CreateActivity: "Crear Actividad",
	Hours: "Horas",
	Minutes: "Minutos",
	TitleConfirmEventCreate: "Cita creada",
	TextConfirmEventCreate: "La cita fue creada exitosamente",
	TitleConfirmEventDelete: "Cita Eliminada",
	TextConfirmEventDelete: "La visita seleccionada fue eliminada exitosamente",
	TitleConfirmEventUpdate: "Visita Actualizada",
	TextConfirmEventUpdate: "La cita seleccionada fue actualizada exitosamente",
	DeleteEvent: "¿Estas seguro de eliminar la visita? Por favor aceptar para continuar.",
	PopupScheduleTitleCreate: "Crear nueva visita",
	CreateSeveralSchedule: "Crear todas las citas",
	PopupScheduleTitleUpdate: "Actualizar Visita",
	ListGroup: "Lista Grupos",
	UpdateGroup: "Actualizar Grupo",
	CreateGroup: "Crear Grupo",
	TitleConfirmGroupCreate: "Grupo creado",
	TextConfirmGroupCreate: "El grupo fue creado exitosamente",
	TitleConfirmGroupDelete: "Grupo Eliminado",
	TextConfirmGroupDelete: "El grupo seleccionada fue eliminado exitosamente",
	TitleConfirmGroupUpdate: "Grupo Actualizado",
	TextConfirmGroupUpdate: "El grupo seleccionada fue actualizado exitosamente",
	ID: "ID",
	Alls: "Todos",
	RemoveFigure: "Eliminar Figura",
	VisualizeVisitPoint: "Visualizar Punto de Visita",
	NoTracking: "Sin seguimiento",
	NotDataExecuteDescription: "No se encontraron datos para pintar la ruta ejecutada",
	NoDating: "Sin citas",
	NotScheduleDescription: "No se encontraron citas programadas para pintar la ruta",
	NoDataAvailable: "Datos no disponibles",
	ValidateField: "El campo {n} es obligatorio",
	Statistics2: {
		Statistics: "Estadisticas",
		VisitsStatistics: "Estadísticas de visitas del mes mostrado en el calendario",
	},
	Crud: {
		Create: "Crear",
		Read: "Leer",
		Update: "Actualizar",
		Delete: "Eliminar",
		List: "Listar",
		Additionals: "Adicionales",
		Modules: "Módulos",
		Cancel: "Cancelar",
		Finalize: "Finalizar",
		Edit: "Editar",
		Add: "Agregar",
		Remove: "Quitar",
	},
	Languages: {
		Languages: "Idiomas",
		Language: "Idioma",
		Spanish: "Español",
		English: "Inglés",
		Portuguese: "Portugués",
		French: "Francés",
		German: "Alemán",
		Spa: "Esp",
		Eng: "Ing",
		Por: "Por",
		Fre: "Fra",
		Ger: "Ale",
	},
	ExportTo: {
		Points: "Exportar Puntos de Visita",
		Resources: "Export Recursos",
	},
	MapModule: {
		Latitude: "Latitud",
		Longitude: "Longitud",
		MapAppearance: "Apariencia del Mapa",
		Coordinates: "Coordenadas",
		CopyCoords: "Copiar Coordenadas",
		GeoAgain: "Georreferenciar de Nuevo",
		ActivateTraffic: "Activar Tráfico",
		DisableTraffic: "Desactivar Tráfico",
		Traffic: "Capa Tráfico",
		Default: "Por Defecto",
		Satellite: "Satélite",
		Hybrid: "Hibrido",
		Terrain: "Terrestre",
		MapOptions: "Opciones del Mapa",
		Route: "Ruta",
		Routes: "Rutas",
		SearchRoutes: "Buscar Rutas",
		RouteType: "Tipo de Ruta",
		RealTimeTracking: "Transmisi\u00F3n",
		NoLocate: "No fue posible localizar este recurso, no se detectaron coordenadas.",
		OnLine: "Conectado",
		OffLine: "Desconectado",
		LastTransmission: "Última transmisión",
		StrokeOpacity: "Opacidad del Trazo",
		StrokeWeight: "Grosor del Trazo",
		StrokeColor: "Color del Trazo",
		OptimizeWaypoints: "Optimizar Puntos",
		ShowWaypoints: "Mostrar Puntos",
		ShowWaypointsText: "Mostrar marcadores de las posiciones reportadas por el dispositivo móvil.",
		ShowWaypointsTextConfirm1: "Habilitar las opciones ",
		ShowWaypointsTextConfirm2: " puede causar lentidtud en la renderizacion y fluidez del mapa.",
		ShowLinearRoute: "Mostrar Linea",
		ShowLinearRouteText:
			"Mostrar una ruta ejecutada con el seguimiento real de las posiciones reportadas por el dispositivo móvil sin tener en cuenta la geometría de la malla vial.",
		ShowLabelText: "Mostrar etiqueta con el número de consecutivo de cada marcador.",
		ShowLabel: "Mostrar Números",
		ScheduledRoute: "Ruta Programada",
		ScheduledRouteZeroResult: "No fue posible trazar una ruta para las visitas programadas.",
		ExecutedRoute: "Ruta Ejecutada",
		ExecutedRouteLinear: "Ruta Ejecutada Lineal",
		ConfigText: "Personaliza algunas de las propiedades visibles para las rutas.",
		CardsView: "Vista de Tarjetas",
		ChangeCardsView: "Cambiar la vista de recursos a tarjetas",
		ChangeListView: "Cambiar la vista de recursos a lista",
		Georeferencer: "Georreferenciador",
		GeoSub: "Georrefrenciar y ubicar en el mapa la dirección ingresada.",
		Views: "vistas",
		ListView: "Vista Lista",
		CardView: "Vista Tarjetas",
		ChangeCardView: "Cambiar la vista a tarjetas.",
		Minimize: "Minimizar",
		Maximize: "Maximizar",
		SeeDayScheduledRoute: "Ver en mapa la ruta programada del día.",
		SeeDayExecutedRoute: "Ver en mapa la ruta ejecutada del día.",
		QuotesDay: "Citas del día",
		SeeListQuotesDay: "Ver listado de citas del dia",
		GenerateRoute: {
			Title: "Error generando ruta",
			Text: "No se encontraron datos para la ruta ejecutada.",
		},
		ErrorGenerateAppointment: {
			Title: "Error creando cita",
			Text: "Error consultando los datos",
		},
		CurrentPosition: "Posición actual",
		CellAutoWith: "Ancho Automático de Celda",
		AlertVisualizarInfo: "Para ver la lista de recursos, seleccione un grupo de la lista en la parte superior.",
		ResourcesNotFound: "No se han encontrado recursos relacionados con el grupo seleccionado.",
		SitidataNoEnabled: "El API de SITIDATA no está habilitada para esta empresa.",
		TrackingInformation: "Información de la Trama",
		Line: "Linea",
		Points: "Puntos",
		Numbers: "Numeros",
		AlertRouteLinear: "Esta opción no está habilitada para rutas con múltiples recursos",
		Georeference: "Georreferenciar",
		GeoreferencingByAddress:
			"Se ha habilitado la georreferenciación por dirección para encontrar las coordenadas y ubicarlas en el mapa, debe hacer",
		DiscardTheChanges: "O para descartar los cambios haga",
		GeoCoordinates: "Georreferenciar y ubicar las coordenadas en el mapa por la dirección ingresada",
		mobile_app_version: "Versión de la aplicación móvil",
		android_os_version: "Versión del sistema operativo Android",
		software_details: "Detalles del software",
		no_transmission: "sin transmisión",
	},
	ListCompanyConfig: {
		TypeConfigName: "Nombre tipo de configuración",
	},
	Roles: {
		Roles: "Roles",
		SelectRole: "Por favor seleccione un rol",
		FormTitleRoleCreate: "Formulario para crear un rol",
		FormTitleRoleEdit: "Formulario para editar un rol",
		CreateLabel: "Crear rol",
		UpdateLabel: "Editar rol",
		ListLabel: "Lista de roles",
		FormInputRoleName: "Nombre de rol",
		FormInputRoleAlias: "Nombre Alias del Rol",
		FormInputRoleDescription: "Descripción del rol",
		FormInputPermit: "Permisos",
		ValidMessages: {
			ValidRoleName: "Ingrese un valor, sin caracteres especiales",
			ValidRoleDescription: "Ingrese un valor",
			ValidRolePermissions: "Seleccionar permisos",
		},
		Permissions: {
			TitleConsultPermissionsError: "Error",
			TextConsultPermissionsError: "Error consultando los permisos",
			NotPermissions: "¡No tienes permiso para esta opción!",
			NotPermissionsTitle: "Sin Autorización",
			NotPermissionsText: "Comuníquese con el administrador de la plataforma para obtener el permiso.",
			RequiredPermissionsText: "Necesitas permisos de",
			JsonConfigNotFoundTex:
				"Es necesario crear una configuración para esta opción. Diríjase al módulo de configuración de empresa.",
			RequiredConfig: "Configuración requerida",
			RequiredConfigText:
				"es una configuración requerida para este proceso, comuníquese con el administrador de la plataforma",
		},
		GetRoles: {
			TitleError: "Error",
			TextError: "Error consultando los roles",
		},
		Create: {
			Title: "Rol Creado",
			Text: "Rol creado con éxito",
			TitleError: "Error",
			TextError: "El rol no ha sido creado",
		},
		Update: {
			Title: "Rol Modificado",
			TextRoleCreated: "Rol modificado con éxito",
			TitleRoleCreatedError: "Error",
			TextRoleCreatedError: "El rol no ha sido modificado",
			Text: "Rol modificado con éxito",
			TitleError: "Error",
			TextError: "El rol no ha sido modificado",
		},
		ListView: {
			columnsNames: {
				Name: "Nombre rol",
				AddedOn: "Añadido",
				Description: "Descripción",
			},
			DeleteRole: {
				TextToConfirm: "Esta seguro de eliminar el rol seleccionado?",
				TitleSuccess: "Rol eliminado",
				TextSuccess: "El rol seleccionado ha sido eliminado",
				TitleError: "Error eliminando el role",
				TextError: "El rol seleccionado no ha sido eliminado",
			},
		},
	},
	Permissions: {
		Permissions: "Permisos",
		RequiredPermissions: "Permisos requeridos",
		FormTitlePermissionCreate: "Formulario para crear un permiso",
		FormTitlePermissionEdit: "Formulario para editar un permiso",
		CreateLabel: "Crear Permiso",
		UpdateLabel: "Editar permiso",
		ListLabel: "Lista de permisos",
		GetPermissions: {
			TitleError: "Error",
			TextError: "Error consultando los permisos",
		},
		GetRole_Permission: {
			TitleError: "Error",
			TextError: "Error consultando las relaciones",
		},
		GetRoles: {
			TitleConsultPermissionsError: "Error",
			TextConsultPermissionsError: "Error consultando los roles",
		},
		FormInputPermissionName: "Nombre permiso",
		FormInputPermissionDescription: "Descripción",
		FormInputRoles: "Roles",
		ValidMessages: {
			ValidPermissionName: "Ingrese un valor, sin caracteres especiales",
			ValidPermissionDescription: "Ingrese un valor",
		},
		Create: {
			Title: "Permiso Creado",
			Text: "Permiso creado con éxito",
			TitleError: "Error",
			TextError: "El permiso no ha sido creado",
		},
		Update: {
			Title: "Permiso Modificado",
			Text: "Permiso modificado con éxito",
			TitleError: "Error",
			TextError: "El permiso no ha sido modificado",
		},
		ListView: {
			columnsNames: {
				Name: "Nombre permiso",
				AddedOn: "Añadido",
				Description: "Descripción",
			},
			DeleteRole: {
				TextToConfirm: "Esta seguro de eliminar el permiso seleccionado?",
				TitleSuccess: "Permiso eliminado",
				TextSuccess: "El permiso seleccionado ha sido eliminado",
				TitleError: "Error eliminando el permiso",
				TextError: "El permiso seleccionado no ha sido eliminado",
			},
		},
	},
	StatusModule: {
		StatusLink: "Estado",
		Create: "Crear Estado",
		ColumnsName: {
			Name: "Nombre del estado",
			Added: "Añadido",
		},
		GetStatus: {
			TitleError: "Error",
			TextError: "Error consultando los estados",
		},
		ValidMessages: {
			ValidName: "Ingrese un valor, sin caracteres especiales",
		},
		PopupCreate: {
			LabelTittle: "Crear estado",
			LabelButton: "Crear",
		},
		ResponseCreate: {
			Title: "Estado creado",
			Text: "Estado ha sido creado correctamente",
			TitleError: "Error",
			TextError: "Estado no ha sido creado correctamente",
		},
		PopupEdit: {
			LabelTittle: "Editar estado",
			LabelInput: "Nombre estado",
			LabelButton: "Editar",
		},
		ResponseEdit: {
			Title: "Estado editado",
			Text: "Estado ha sido editado correctamente",
			TitleError: "Error",
			TextError: "Estado no ha sido editado correctamente",
		},
		PopupDelete: {
			LabelText: "Esta seguro de eliminar el estado seleccionado?",
		},
		ResponseDelete: {
			Title: "Estado eliminado",
			Text: "Estado ha sido eliminado correctamente",
			TitleError: "Error",
			TextError: "Estado no fue eliminado correctamente",
		},
	},
	StatusMobile: {
		StatusMobile: "Estados para móviles",
		StatusMobileName: "Nombre Estado para Móvil",
		ListStatusMobile: {
			ListStatusMobile: "Lista de Estados para Móviles",
			Description: "Descripción",
			ActiveForm: "Formulario Activo",
			ActiveEventToltip:
				"Esta opción indica si en el estado actual es posible o no iniciar eventos (visitas). Por ejemplo activar para permitir iniciar visitas en el almuerzo.",
			ActiveEvent: "Iniciar Eventos",
			ZoneRequired: "Zona Requerida",
			ZoneRequiredToltip:
				"Esta opción restringe si en la aplicación móvil (recurso) es posible o no activar un estado dentro o fuera de su zona asignada.",
			Status: "Estado",
			Active: "Activado",
			Disabled: "Desactivado",
			Company: "Empresa",
			ErrorTitle: "Estado no fue actualizado",
			ErrorStatus: "Los estados no se pueden cambiar hasta que el móvil haya transmitido al menos una vez",
		},
		FormStatusMobile: {
			CreateStatusMobile: "Crear Estado para Móvil",
			UpdateStatusMobile: "Actualizar Estado para Móvil",
			FormTitleCreate: "Formulario para crear un estado para móvil",
			FormTitleUpdate: "Formulario para editar un estado para móvil",
			ValidMessages: {
				Name: "Ingrese un valor, sin caracteres especiales",
				Description: "Ingrese un valor",
			},
			Create: {
				Success: {
					Title: "Estado para móviles",
					Text: "Creado exitosamente",
				},
				Error: {
					Title: "Estado para móviles",
					Text: "No se ha creado exitosamente",
				},
			},
			Update: {
				Success: {
					Title: "Estado para móviles",
					Text: "Editado exitosamente",
				},
				Error: {
					Title: "Estado para móviles",
					Text: "No se ha editado exitosamente",
				},
			},
			Delete: {
				Text: "Está seguro de eliminar el estado para móvil seleccionado?",
				Success: {
					Title: "Estado para móviles",
					Text: "Eliminado exitosamente",
				},
				Error: {
					Title: "Estado para móviles",
					Text: "No se ha eliminado exitosamente",
				},
			},
		},
	},
	NewTipology: {
		name: "Escriba Nombre",
		description: "Escriba una descripción aquí",
	},
	Resource: {
		Resource: "Recurso",
		Resources: "Recursos",
		DeleteResource: "Eliminar Recurso",
		DeleteResources: "Eliminar Recursos",
		DeleteAllResources: "Eliminar todos los recursos",
		AssigResources: "Asignar Recursos",
		NotResources: "No hay recursos asignados",
		AssignResourceToltip: "Cargar el listado de recursos disponibles para continuar con la asignaci\u00F3n.",
		ShowAssigneResource: "Ver Rescursos Asignados",
		ShowAssigneResourceToltip: "Ver listado de recursos actualmente asignados a esta operaci\u00F3n.",
		EmailInvalid: "La dirección de correo electrónico no tiene formato valido",
		UsernameInvalid: "El nombre de  usuario es demasiado corto, mínimo 5 caracteres.",
		emailRequired: "El correo electrónico es requerido",
		identificationRequired: "La identificaci\u00F3n es requerido",
		lastnameRequired: "El apellido es requerido",
		nameRequired: "El nombre es requerido",
		usernameRequired: "El nombre de  usuario es requerido",
		BackButton: "Atras",
		FinishButton: "Finalizar",
		Definition: "Definición",
		ObjectProperties: "Propiedades del objeto",
		Summary: "Resumen",
		ObjectCreated: "Objeto creado",
		Loading: "Cargando...",
		TotalResources: "Total recursos",
		NoticeNewObject: {
			Text1: "Va a crear un nuevo objeto",
			Text2: "de tipo",
			Text3: "con las propiedades descritas a continuación, por favor valide la información y presione",
			Text4: "para proceder a la creación.",
		},
		PrincipalProperties: "Propiedades Principales",
		Continue: "Continuar",
		AdditionalProperties: "Propiedades Adicionales",
		DeleteAllText: "¿Está seguro de quitar todos los recursos de la tabla?",
		SearchMultipleId: "Buscar múltiples resultados ingresando ids separados por comas",
		FinalizeContent: {
			Message:
				"El nuevo objeto fue creado con éxito y está listo para ser utilizado, selecciona una de las siguientes opciones para finalizar el este proceso",
			CreateResource: "Crear Recurso",
			CreateVisitPoint: "Crear Punto de Visita",
			ViewAllObject: "Ver todos los objetos",
		},
		NameInvalid: {
			Title: "Nombre no valido",
			Text: "El nombre del objeto no acepta acentos ni caracteres especiales",
			Text1: "El nombre del objeto solo acepta letras y números.",
		},
		SchemeInvalid: {
			Title: "Esquema no valido",
			Text: "Seleccione un esquema para poder continuar con la creación del objeto",
		},
		CorrectAllValues: "corregir todos los valores",
		List: {
			CellRenderer: {
				DeleteRecord: "Está a punto de borrar",
				DeleteSuccess: {
					Title: "Recurso eliminado",
					Text: "El recurso seleccionado ha sido eliminado con éxito",
				},
			},
		},
		Create: {
			TabLabel: "Crear Recurso",
			LoadResourcesType: "Cargando tipos de recursos!",
			ReosurceType: "Tipo de recurso",
			SelectType: "Seleccione el tipo de objeto para renderizar el formulario.",
			Success: {
				Title: "Recurso creado",
				Text: "Se creó un nuevo recurso en el sistema.",
			},
		},
		Edit: {
			EditResource: "Editar Recurso",
			UserNotFound: {
				Text1: "Registro de usuario con id:",
				Text2: "no encontrado.",
				Check: "Verificar",
				AllUsers: "Todos los usuarios",
			},
			ValidMessages: {
				Username: "El campo username es requerido, sin caracteres especiales ni espacios",
				Email: "El campo email es requerido, con el formato correcto",
				Status: "El campo status es requerido",
				Lastname: "El campo lastname es requerido",
				Identification: "El campo identification es requerido",
				Nombre: "El campo name es requerido, sin caracteres especiales ni números",
				Role: "El campo rol es requerido",
				Dynamic: {
					Text1: "El campo",
					Text2: "es requerido",
				},
				VisitPointInactive:
					"No es posible actualizar el recurso porque tiene asignado puntos de visita inactivos o no encontrados, por favor revise los puntos de visita con id:",
			},
		},
		View: {
			AssignedActivities: "Actividades asignadas",
			NotAssignedActivities: "No hay actividades asignadas",
			NotImeiCode:
				"No tiene un código imei registrado, es posible que el recurso nunca haya iniciado sesión desde la aplicación movil",
		},
	},
	ErrorVariable: {
		Textvariable1: "Campo incorrecto o vacio!",
	},
	Object: {
		Object: "Objeto",
		CreateObject: "Crear Objeto",
		AdditionalFields: "Campos Adicionales",
		AdditionalField: "Campo Adicional",
		NotAdditionalFields: "Objeto no tiene campos adicionales",
		PrincipalFields: "Campos Principales",
		TypeField: "Tipo de Campo",
		Required: "Obligatorio",
		Yes: "Si",
		Not: "No",
		Label: "Etiqueta",
		LabelHelp: "Nombre visible en el formulario",
		Options: "Agregar opciones escriba: ( Valor opción:Color en ingles )",
		OptionsLabel: "Ejemplo: Opción1:Black ",
		Property: "Propiedad",
		Properties: "Propiedades",
		PropertyDefinition: "Definici\u00F3n de Propiedad",
		EnableEditing: "Habilitar edici\u00F3n",
		ChangeName: "Cambiar Nombre",
		SaveChanges: "Guardar Cambios",
		TypeName: "Escribe un nombre",
		EnterNewName: "Ingrese el nuevo nombre",
		ChangeObjectName: "Cambiar nombre del objeto",
		ObjectName: "Nombre del objeto",
		TypeLabel: "Escribe una etiqueta",
		Basics: "Básicos",
		ValidMessages: {
			name: "El campo nombre es obligatorio, sin caracteres especiales ni espacios",
			label: "El campo etiqueta es obligatorio",
			status: "El campo estado es obligatorio",
			cat: "El campo categoria es obligatorio",
		},
		DeleteObject: {
			Text1: "¿Estas seguro de eliminar el objeto",
			Text2: "Por favor aceptar para continuar.",
		},
		DeleteField: {
			Text1: "¿Estas seguro de eliminar el campo",
			Text2: "Por favor aceptar para continuar.",
		},
		NumProperties:
			"Seleccione un esquema para ver las propiedades mínimas que el objeto puede tener o así como también poder agregar nuevas propiedades de este.",
		SelectSchemeLabel: "SELECCIONE ESQUEMA",
		SelectSchemeValue: "SELECCIONE_ESQUEMA",
		SelectedTipology: {
			label: "recursos",
		},
		Field: {
			label: "Texto",
		},
		statusOptions: {
			Date: "Fecha",
			DateTime: "Fecha y hora",
			Text: "Texto",
			Number: "Numero",
			Email: "Correo electrónico",
			Select: "Selección",
			Url: "Url",
			File: "Archivo",
			Image: "Imagen",
			Coordinates: "Coordenadas",
			DefaultLocation: "Localización por defecto",
			Radio: "Varias opciones",
			Checkbox: "Casillas",
			Dropdown: "Desplegable",
			Switch: "Booleano",
			Composed: "Compuesta",
			MultipleChoice: "Selección multiple",
		},
		nameOptions: {
			VISIT_POINT: "PUNTO DE VISITA",
			RESOURCE: "RECURSO",
			SCHEDULE: "CALENDARIO",
			LAYER: "CAPA",
		},
		ErrorFields: {
			Title: "Error en campos",
			Text: "Algunos campos faltan o no son válidos",
		},
		UserDeleted: {
			Title: "Usuario eliminado",
			Text: "El usuario seleccionado se eliminó con éxito.",
		},
		UserInvalid: {
			Title: "Nombre no valido",
			Text: "El nombre del objeto solo acepta letras y numeros.",
		},
	},
	VisitPointObject: {
		Create: {
			SelectObjectType: "Seleccionar tipo de objeto",
			ValidMessages: {
				ObjectType: "El tipo de objeto es requerido",
				Name: "El campo de nombre es requerido",
				Identification: "El campo de identificación es requerido, sin caracteres especiales ni espacios",
				Phone: "El campo de teléfono es requerido",
				Address: "El campo de dirección es requerido",
				Country: "El campo país es requerido",
				Departament: "El campo departamento es requerido",
				City: "El campo ciudad es requerido",
			},
			LabelInfoObjectType: "Por favor seleccione el tipo de objeto para la creación del punto de visita.",
			GeoFindNextAddress: "El georreferenciador encontró la siguiente dirección para las nuevas coordenadas:",
			UseAddressQuestion: "¿Desea utilizar esta dirección para el punto de visita?",
			Success: {
				Title: "Punto de visita creado",
				Text: "Se creó un nuevo punto de visita.",
			},
			ErrorRegisterValidate: {
				Title: "Campos faltantes",
				Text: "Campos faltantes en información adicional",
			},
			FindAddress: {
				Title: "Dirección Encontrada",
				Text: "Dirección georeferenciada exitosamente.",
			},
			ErrorFindAddress: {
				Title: "Dirección no Encontrada",
				Text: "El georeferenciador no encontro la direccion ingresada",
			},
			MissingAddress: {
				Title: "Dirección Requerida",
				Text: "La dirección es requerida por el georreferenciador.",
			},
			ErrorFindCountry: {
				Title: "Cobertura no encontrada",
				Text: "Verifique que el país elegido coincida con el país donde está arrastrando el marcador",
			},
			GeoRefFindAddress:
				"El georreferenciador encontró una nueva dirección para las nuevas coordenadas\n Desea remplazar la dirección por",
			WithoutResource: "No ha asignado ningún recurso, ¿está seguro de continuar?",
		},
		Edit: {
			VisitPointNotFound: {
				Title: "Punto de Visita no encontrado",
				Text1: "Registro de punto de visita con id:",
				Text2: "no encontrado.",
			},
			AllVisitPoints: "Todos los puntos de visita",
			ValidMessages: {
				ObjectType: "El tipo de objeto es requerido",
				Name: "El campo de nombre es requerido",
				Identification: "El campo de identificación es requerido, sin caracteres especiales ni espacios",
				Phone: "El campo de teléfono es requerido",
				Address: "El campo de dirección es requerido",
				Country: "El campo país es requerido",
				Departament: "El campo departamento es requerido",
				City: "El campo ciudad es requerido",
				Status: "El campo estado es requerido",
			},
			Success: {
				Title: "Punto de visita actualizado",
				Text: "El punto de visita se actualizó correctamente",
			},
			Error: {
				Title: "Error en la edición",
				Text: "Ocurrió un error durante la actualización",
			},
		},
		List: {
			NotSchedule: "No Agendados",
			InvalidRangeOfDateTitle: "Rango de Fechas Inválidos",
			InvalidRangeOfDateMsj: "El rango de días entre las fechas no puede ser superior a 31.",
			CellRenderer: {
				DeleteRecord: "Está a punto de borrar",
				DeleteSuccess: {
					Title: "Punto de Visita eliminado",
					Text: "El punto de visita seleccionado se eliminó con éxito",
				},
			},
			MassiveDelete: {
				Confirm: {
					Title: "Eliminaci\u00F3n Masiva",
					Text: "¿Esta seguro de continuar con la eliminaci\u00F3n de los puntos de visita?",
				},
				Success: {
					Title: "Punto de visita eliminado",
					Text: "El punto de visita seleccionado se eliminó con éxito",
				},
			},
			SelectVisitPoint: {
				Title: "Seleccionar puntos de visita",
				Text: "No has seleccionado ningún punto de visita",
			},
		},
		Assig: "Asignar",
		AssignVisitPoints: "Asignar puntos de visita",
		AssignedVisitPoint: "Punto de visita Asignado",
		AssignedVisitPoints: "Puntos de visita Asignados",
		NoAssignedVisitPoints: "No hay puntos de visita asignados",
		AssigneVisitPointText: "Seleccione los puntos de visita que desea asignar.",
		AssignedResourceByZonesTextAlert:
			"La asignación de recursos por zonas a los puntos de visita se encuentra activa, si elimina recursos del listado, es posible que después de guardar los cambios algunos de estos no sean desasignados debido a esta configuración",
		Columns: "Columnas",
		ColumnsText: "Seleccione las columnas que desea renderizar en la tabla",
		TotalVisitPoints: "Total puntos de visita",
		AssignVisitPointToltip: "Cargar el listado de puntos de visita disponibles para continuar",
		AssignAllVisitPointText: "Asignar todos los puntos de visita de la plataforma",
	},
	Activity: {
		Activity: "Actividad",
		AssignedResources: "Recursos Asignados",
		AssignedGroups: "Grupos Asignados",
		AssignedGroupsError: "Ocurrio un error consultando los grupos asignados. Porfavor intentelo de nuevo!",
		AlertMissingForm: 'Es necesario seleccionar un formulario si la opción "Formulario activo" está activada.',
		AlertFormNotFoundTitle: "Formulario no encontrado.",
		AlertFormNotFoundText:
			"La actividad tiene un formulario asiganado  que no se encuentra en el listado de formularios disponibles.",
		ActivateForm: "Formulario Activo",
		Form: "Formulario",
		ServiceTime: "Tiempo de Servicio",
		Activated: "Activado",
		Inactivated: "Inactivado",
		ActivityListEmpty: "No hay actividades registradas",
		ActivityHasNoAssignedResources: "La actividad no tiene recursos asignados",
		Activities: "Actividades",
		AssignActivities: "Asignar actividades",
		AssignedActivities: "Actividades asignadas",
		LoadActivityListToltip: "Cargar el listado de actividades disponibles para continuar con la asignaci\u00F3n.",
		TotalActivities: "Total actividades",
		DRPointsRequired: "Dr Points requeridos, mínimo 0 para continuar",
	},
	ActivityValidMessages: {
		ItemName: "El campo nombre es obligatorio",
	},
	Schedule: {
		Schedules: "Agendas",
		SelectionMode: "Selección de visitas",
		AdditionalFields: "Campos Adicionales",
		AdditionalFieldsAlert: "Si desea agregar o editar campos adicionales seleccione un tipo de objeto.",
		AddNewVisit: "Nueva Visita",
		SelectResource: "Seleccionar Recurso",
		Refresh: "Recargar",
		ResourceList: "Lista de Recursos",
		SearchSchedule: "Buscar Agendas",
		CancelVisit: "Cancelar Visita",
		CreateVisit: "Crear Visita",
		CreateVisits: "Crear Visitas",
		ActivityNoAvailable:
			"Actividad no disponible para este recurso, diríjase al módulo de actividades y haga la asignación.",
		Repeat: "Repetici\u00F3n",
		CurrentVisitPointAssigned: "Actual Punto de Visita Asignado",
		ToAssigVisitPoint: "Click en el bot\u00F3n buscar, para asignar uno.",
		ActiveApi: "Activar Api",
		SchedulingApiNotEnabled: "El API de agendamiento no esta habilitada para esta empresa.",
		ServiformApiNotEnabled: "El API de serviforms no esta habilitada para esta empresa.",
		Month: "Mes",
		Week: "Semana",
		Day: "Día",
		ErrorProcess: {
			Title: "Error",
			Text: "Ocurrió un error durante el proceso",
			InitHourError: "La hora inicial debe ser mayor a la hora actual",
			VisitpointError: "El punto de visita no esta asignado al recurso seleccionado",
			ResourceActivityError: "La actividad seleccionada no esta asignada al recurso seleccionado",
		},
		SelectInitTime: "Seleccionar hora inicial",
		SelectEndTime: "Seleccionar hora final",
		ValidEndOur: "La hora final no puede ser menor que la hora inicial.",
		ValidDinamicFields: {
			Text1: "El campo",
			Text2: "es requerido",
		},
		AssignVisitPointText: "Por favor asigne un punto de visita para crear la cita.",
		SelectVisitPointText: "Seleccione el punto de visita que desea asignar a la cita.",
		SelectVisitPointTextAlarm: "Seleccione los puntos de visita que desea asignar a la alarma.",
		None: "Ninguna",
		Monday: "Lunes",
		Tuesday: "Martes",
		Wednesday: "Miércoles",
		Thursday: "Jueves",
		Friday: "Viernes",
		Saturday: "Sábado",
		Sunday: "Domingo",
		MondayToFriday: "De lunes a viernes",
		EveryDay: "Todos los días",
		MondayToSaturday: "DE LUNES A SABADO",
		MondayAndFriday: "MARTES Y JUEVES",
		MondayWednesdayAndFriday: "LUNES,MIÉRCOLES Y VIERNES",
		Weekend: "FIN DE SEMANA",
		WeekMayus: "Semanal",
		MonthMayus: "Mensual",
		Finished: "Finalizado",
		Finalize: "Finalizar Visita",
		InProgress: "En Proceso",
		OnTheWay: "En Camino",
		Delayed: "Demora",
		ReProgramming: "Reprogramado",
		Canceled: "Cancelado",
		Scheduled: "Agendado",
		NotAssigned: "No Asignado",
		InvalidFields: "Campos Inválidos",
		ValidData: {
			Title: "Valide los datos",
			Text: "Faltan algunos campos importantes",
			DayLessThanCurrentDayTitle: "Día no valido",
			DayLessThanCurrentDay: "El día de la visita no debe ser menor al día actual",
		},
		SelectResourceText: "Seleccione un recurso para ver las visitas en el calendario",
		ListofEventsDay: "Lista de visitas para el día seleccionado",
		SelectDateToSeeEvents: {
			Text1: "Seleccione la",
			Text2: "fecha",
			Text3: "de las visitas.",
		},
		EventsOnTheMap: "Visitas en el mapa",
		Reassign: "Reasignar Visitas",
		ReassignTextConfirm:
			"Para reasignar correctamente las visitas, el recurso seleccionado debe tener las mismas actividades asignadas. Por favor aceptar para continuar.",
		ReassignTextError:
			"visitas no se pudieron reasignar , asegúrese de que el recurso seleccionado tenga asignadas las actividades requeridas.",
		ReassignDate: "Nueva fecha de reasignaci\u00F3n.",
		Visit: "Visita",
		ReassingResourceText: "Por favor seleccione un recurso del listado para reasignar las visitas",
		FilterVisitPointBy: "Filtrar puntos de vista por",
		ReviewVisits: "Revisar Visitas",
		DeleteVisit: "Eliminar visita",
		DeleteVisitTextConfirm: "¿Está seguro de eliminar la visita del sistema?",
		FilterByAdditionalFields: "Filtrar información por campos adicionales",
		FilterByAdditionalFieldsText:
			"Seleccione el tipo de objeto y asigne los valores a cada una de las propiedades por las que desea filtrar la información.",
		ReadyVisitsToAssign: "Visitas listas para asignar al recurso",
		ReadyVisitsToAssignText:
			"Las siguientes visitas están listas para ser asignadas al recurso. puede eliminarlas o hacer clic en el botón asignar para finalizar el proceso.",
		NotReadyVisitsToAssign:
			"No hay visitas listas para asignar, complete la información del formulario y haga clic en el botón agregar visita.",
		AddVisit: "Agregar Visita",
		VisitInformation: "Información de la Visita",
		VisitInformationText:
			"Complete la información de la visita y haga clic en el botón agregar visita para continuar.",
		AssignResource: "Asignar Recurso",
		AssignResourceText:
			"Seleccione el recurso al que desea asignar a las visitas y asi poder cargar las actividades asignadas a este y continuar con el proceso.",
		OpenAvailableResources: "Abrir Recursos Disponibles",
		ClickToOpenAvailableResources: "Haga clic para abrir la lista de recursos disponibles",
		ClickOnEditVisit: "Haga clic en el botón editar para modificar la información de la visita.",
		UpdateVisitInformation: "Actualizar Información de la Visita",
		UpdateVisitInformationText:
			"Actualice la información de la visita y clic en el botón reprogramar para guardar los cambios realizados.",
		RescheduleVisit: "Reprogramar Visita",
		ConfirmActionQuestion: "¿Está seguro de {n} la visita, esta acción no se puede deshacer?",
		VisitScheduling: "Agendamiento de Visitas {n}",
		VisitSchedulingText:
			"Puede agendar una o varias visitas a la vez, complete la información de la visita y haga clic en el botón agregar visita.",
		VisitRescheduling: "Reprogramación de Visitas {n}",
		VisitReschedulingText:
			"Solo es posible reprogramar una visita a la vez, actualice la información de la visita y haga clic en el botón reprogramar.",
		ScheduleVisits: "Agendar Visitas",
		ViewCalendar: "Ver Calendario",
	},
	DeleteGroup: {
		Text1: "¿Estas seguro de eliminar el grupo",
		Text2: "Por favor aceptar para continuar.",
	},
	GroupValidMessages: {
		ItemName: "El campo nombre es obligatorio",
		ItemAddress: "El campo dirección es obligatorio",
	},
	Groups: {
		Groups: "Grupos",
		TotalGroups: "Total Grupos",
		Group: "Grupo",
		AssigneGroup: "Asignar Grupo",
		AssignGroups: "Asignar Grupos",
		AssignedGroup: "Grupo Asignado",
		AssignedGroups: "Grupos Asignados",
		NoAssignedGroups: "No hay grupos asignados",
		AssigneGroupToltip: "Cargar el listado de grupos disponibles para continuar con la asignaci\u00F3n.",
		ShowAssigneGroup: "Ver Grupos Asignados",
		ShowAssigneGroupToltip: "Ver listado de grupos actualmente asignados a esta operaci\u00F3n.",
		AssigneGroupRequired: "La asignaci\u00F3n de grupo es requerida",
		ClickOnButton: "Click en el bot\u00F3n",
		DeleteAllGroups: "Eliminar todos los grupos",
		AvailableGroups: "Grupos disponibles",
		Favorite: "Favorito",
		FavoriteConfirmText:
			"establecer como grupo predeterminado para visualización de transmision al iniciar session en la plataforma, lo podra visualizar y cambiar rapidamente desde la barra superior",
		AskForAgain: "Preguntar de nuevo",
		DefaultGroup: "Grupo Predeterminado",
		FavoriteRemoveConfirmText:
			"Quitar la opción de selección de grupo predeterminado de la barra superior de la plataforma, podra activarla nuevamente desde las preferencias.",
	},
	Alarm: {
		Alarm: "Alarma",
		Alarms: "Alarmas",
		BatteryAlarms: "Alarmas de Bater\u00EDa",
		RadioAlarm: "Alarma de Incio y Cierre de Agenda",
		Radio: "Radio",
		DefineRadius: "Establecer rádio",
		GpsAlarms: "Alarmas de GPS",
		UpdateAlarm: "Actualizar Alarma",
		CreateAlarm: "Crear Alarma",
		BatteryLevel: "Nivel de Bater\u00EDa",
		AlarmList: "Lista de Alarmas",
		ScheduleAlarms: "Alarma de Agendas",
		TotalVisit: "Total Visitas",
		NoAssignedEmail: "No hay correos electr\u00F3nicos asignados",
		ZoneAlarms: "Alarmas de Zona",
		ZoneAlarmsType: "Tipo",
		SelectAll: "SELECCIONAR TODOS",
		MissingFields: {
			Title: "Falan campos",
			Text: "El nivel de bater\u00EDa debe ser mayor a 0 y menor que 100",
		},
		ValidFields: {
			Name: "El campo nombre es requerido",
			EndTime: "El campo hora final es requerido",
			Email: "El campo correo electrónico es requerido y debe ser un correo valido",
		},
		SelectInitTime: "Seleccionar hora inicial",
		SelectEndTime: "Seleccionar hora final",
		AssignedResources: "Recursos Asignados",
		AssignedZones: "Zonas asignadas",
		AddResources: "Agregar Recursos",
		LoadListResources: "Cargar listado de recursos para asignar a la alarma.",
		DeleteResources: "Eliminar Recursos",
		DeleteAllResources: "Eliminar todos los recursos.",
		DeleteAllVisitPoints: "Eliminar todos los puntos de visita.",
		AssignedEmails: "Correos electronicos asignados",
		DeleteEmails: "Eliminar correos",
		DeleteAllEmails: "Eliminar todos los correos",
		NotAssignEmail: "No hay correos electronicos asignados",
		DeleteAllText: "Estás a punto de borrar todo",
		ErrorGetResourceFilter: {
			Title: "Error",
			Text: "Ocurrio un error consultando recursos asignados.",
		},
		DeleteYouAre: "Estás a punto de borrar",
		MissingFieldsSchedule: {
			Title: "Faltan campos",
			Text: "El total de visitas debe ser mayor a 0",
			Text2: "La zona es un valor requerido",
		},
		ZoneTypes: {
			Input: "Entrada",
			Output: "Salida",
			InputAndOutput: "Entrada y Salida",
		},
		TitleConfirmAlarmCreate: "Alarma Creada",
		TextConfirmAlarmCreate: "La alarma fue creada exitosamente.",
		TitleConfirmAlarmDelete: "Alarma Eliminada",
		TextConfirmAlarmDelete: "La alarma fue eliminada exitosamente.",
		TitleConfirmAlarmUpdate: "Alarma Actializada",
		TextConfirmAlarmUpdate: "La alarma fue actualizada exitosamente.",
		ValidInitHour: "La hora inicial debe ser menor que la hora final.",
		ValidEndHour: "La hora final debe ser mayor que la hora inicial.",
		DateInitError: "La fecha inicial no puede ser mayor a la fecha final.",
		AssignateTo: "Asignar alarma a",
		EventToNotify: "Tipo de evento a notificar",
		Start: "Inicio de visita",
		End: "Cierre de visita",
		Startandend: "Inicio y cierre de visita",
		SpeedAlarm: "Alarma de Velocidad",
		Speed: "Velocidad",
		ValidSpeed: "La velocidad debe estar entre 1 y 200",
		ValidSpeedRequired: "El campo velocidad es requerido",
	},
	Zonification: {
		Zonification: "Zonificaci\u00F3n",
		View: "Ver",
		Draw: "Dibujar",
		ReplacePolygonConfirmTitle: "Remplazar Polígono",
		ReplacePolygonConfirmText: "¿Esta seguro de remplazar el polígono de la zona seleccionada?",
		Tools: "Herramientas",
		AlertTextOne: "Por favor seleccione el recurso al que desea asignar las zonas a través de la opción",
		DeleteZoneResourceConfirmTitle: "Eliminar Asignaci\u00F3n",
		DeleteZoneResourceConfirmText:
			"¿Está seguro de eliminar todas las zonas asignadas con este recurso? Por favor acepta para continuar.",
		DeleteAssignationSuccess: "Asignaci\u00F3n Eliminada",
		DeleteAssignationSuccessText: "Todas las zonas fueron desasignadas del recurso exitosamente.",
		CreateAssignationSuccess: "Asignaci\u00F3n Creada",
		CreateAssignationSuccessText: "La asignaci\u00F3n de zonas fue creada exitosamente.",
		UpdateAssignationSuccess: "Asignaci\u00F3n Actualizada",
		UpdateAssignationSuccessText: "La asignaci\u00F3n de zonas fue actualizada exitosamente",
		AlertSelectLayerTitle: "Selecione Capa y Zonas",
		AlertSelectLayerText:
			"Ahora, seleccione una capa para ver la lista de zonas disponibles para asignar al recurso seleccionado.",
		AlertSelectLayerText2: "use el bot\u00F3n",
		AlertSelectLayerText3: "para guardar los cambios realizados o",
		AlertSelectLayerText4: "para eliminar las actuales asignaciones.",
		Zone: "Zona",
		Zones: "Zonas",
		ZonesNotFound: "No se encontró información de zonas asignadas o fueron eliminadas del  sistemas.",
		AssignedZone: "Zona Asignada",
		Circle: "Circulo",
		Rectangle: "Rectangulo",
		Polygon: "Polígono",
		Polyline: "Polilínea",
		Marker: "Marcador",
		FillColor: "Color de relleno",
		NewLayer: "Nueva capa",
		EditInfo: "Editar Info",
		RemoveZones: "Eliminar Zonas",
		Layer: "Capa",
		EditName: "Editar Nombre",
		Layers: "Capas",
		UseTool: "Utilice la Herramienta",
		DrawAndAddZones: 'para dibujar y agregar zonas a la capa, las cuales se listaran en el desplegable de "Zonas"',
		AssignNameLayer: "Por favor asigne un nombre de capa.",
		NameLayer: "Nombre de la capa",
		EditZoneSelected:
			"Editar informaci&oacute;n de la zona seleccionada, asigne un nuevo nombre o una descripci&oacute;n.",
		AddZoneInLayer: "Para agregar esta zona a la capa, asignele un nombre y una descripcion",
		AddZone: "Agregar Zona",
		CreateNewLayer: "Crear Nueva Capa",
		UpdateNameLayer: "Actualizar Nombre Capa",
		DragToRelocate: "Arrastre para reubicar",
		CurrentPosition: "Posición actual",
		UpdateLayerSuccess: {
			Title: "Capa Actualizada",
			Text: "El nombre de la capa se actuaz\u00F3 correctamente.",
		},
		RemoveLayer: {
			Title: "Capa Eliminada",
			Text: "Capa eliminada exitosamente.",
		},
		UpdateZone: {
			Title: "Zona actualizada",
			Text: "El area de la zona fue modificada exitosamente",
			Text2: "Informaci\u00F3n de la zona se actualiz\u00F3 exitosamente.",
		},
		AddZones: {
			Title: "Zona Agregada",
			Text: "Nueva zona agregada a la capa actual.",
		},
		ErrorInsertZones: {
			Title: "Error Agregando",
			Text: "Ocurri\u00F3 un error agregando la nueva zona a la capa, intentelo nuevamente.",
		},
		ErrorRemoveZones: {
			Title: "Error Eliminado",
			Text: "Ocurri\u00F3 un error durante la eliminaci\u00F3n de zonas, intentelo nuevamente.",
		},
		RemoveLayerMessage: {
			Title: "Capa eliminada",
			Text: "La capa y todas sus zonas fueron eliminadas correctamente.",
		},
		RemoveZoneMessage: {
			Title: "Zonas Removidas",
			Text: "La zonas seleccionadas fueron removidas.",
		},
		RemoveZonesInLayer: {
			Title: "Capa Eliminada",
			Text: "La capa y todas sus zonas se eliminaron correctamente.",
		},
		ErrorRemoveZonesInLayer: {
			Title: "Error Eliminado",
			Text: "Ocurri\u00F3 un error durante la eliminaci\u00F3n de todas la zonas de la capa, intentelo nuevamente.",
		},
		RemoveLayerConfirmation: {
			Title: "Eliminacion Capa",
			Text: "Esta seguro de eliminar toda la capa y sus respectivas zonas?",
		},
		ErrorUpdateZoneInfo: {
			Title: "Error Actualizando",
			Text: "Error durante la actualizaci\u00F3 de la informaci\u00F3n, intentelo nuevamente.",
		},
		SelectZones: {
			Title: "Seleccione Zonas",
			Text: "No ha seleccionado ninguna zona.",
		},
		ConfirmRemoveLayerAndZones: {
			Title: "Confirmar Eliminacion",
			Text: "Esta seguro de eliminar toda la capa y sus respectivas zonas?",
		},
		ConfirmRemoveSelectedZones: {
			Title: "Confirmar Eliminacion",
			Text: "Esta seguro de eliminar todas las zonas seleccionadas?",
		},
		UploadZones: {
			SelectFileText: "Seleccione un archivo para iniciar el cargue",
			FileName: "Seleccionar Archivo",
			Success: {
				Title: "Subida exitosa",
				Text: "El archivo fue subido exitosamente",
			},
			Error: {
				Title: "Error al Subir",
				Permission: "El usuario no tiene permiso para acceder al objeto",
				Cancel: "El usuario canceló la carga",
				Unknown: "Ocurrió un error desconocido, inspeccione error.serverResponse",
			},
		},
		FormGeo: {
			FindCoords: "El georreferenciador encontró la siguiente dirección para las nuevas coordenadas:",
			AskUseDirection: "¿Desea utilizar esta dirección para el punto de visita?",
			FindDirection:
				"El georreferenciador encontro una nueva direccion para las nuevas coordenadas \n Desea reemplazar la direccion por",
		},
	},
	UploadFiles: {
		UploadFiles: "Cargue de Archivos",
		UploadSuccess: "Cargue Exitoso",
		UploadSuccessMessage: "El archivo fue cargado con éxito.",
		UploadError: "Cargue Fallido",
		UploadErrorMessage:
			"Se produjo un error durante la subida del archivo, compruebe si el archivo tiene la estructura básica o descargue los archivos de ejemplo",
		UploadType: "Tipo de Cargue",
		UploadTypeSelectToltip: "Define el tipo de cargue de archivo.",
		UploadTypeObjectToltip: "Define la estructura del archivo a cargar teniendo en cuenta sus campos adicionales.",
		UploadTypeCountryTooltip: "Selecciona el país donde se georreferenciarán los puntos de visita a cargar.",
		SelectFile: "Seleccionar Archivo",
		UploadSuccessTextAlert:
			"El archivo fue cargado con éxito y está siendo procesado en segundo plano, verifique o espere las notificaciones del sistema para conocer el estado del proceso.",
		FileReadyToBeUploaded: "Archivo listo  para ser cargado.",
		Details: "Detalles",
		Size: "Tamaño",
		DownloadFailed: "Descarga Fallida",
		DownloadFailedText: "Descarga fallida, archivo no encontrado o fue eliminado del servidor",
		FileNotFound: "Archivo no encontrado",
		DownloadFormat: "Descargar archivo base",
		DownloadFormatText:
			"Descargar un archivo base o plantilla en el formato seleccionado que contiene la estructura requerida para el tipo de cargue seleccionado",
		Format: "Formato",
		InvalidFormatFile: "Tipo de formato invalido",
		InvalidFormatFileText:
			"Por favor seleccione un archivo con el formato requerido, solo se permiten archivos en formato .xlsx, .xls, .csv, .json o .xml",
	},
	Reports: {
		Report: "Reporte",
		Reports: "Reportes",
		GenerateReport: "Generar un reporte",
		GenerateReportInfo: "Para generar un nuevo reporte, seleccione el tipo de reporte que desea generar",
		AlertTextOne: "Por favor seleccione los recursos asociados al reporte a través de la opción",
		AlertTextTwo: "para continuar con el proceso.",
		NoDataReportTitle: "No se econtraron datos",
		NoDataReport: "No se encontraron datos para este tipo de reporte.",
		NoDataReportInDates: "No se encontraron datos para las fechas establecidas.",
		ReportGeneratedTitle: "Reporte Generado",
		ReportGeneratedText: "Reporte generado exitosamente.",
		loginout: "Inicio y Cierre de Sesi\u00F3n",
		scheduledroute: "Ruta Programada",
		scheduledroutevsexecuted: "Ruta Programada vs Ejecutada",
		location: "Localizaci\u00F3n",
		LocationDescription: "Este reporte devuelve la última posición de los recursos.",
		historicalposition: "Hist\u00F3rico de Posici\u00F3n",
		HistoricalpositionDescription: "Este reporte exporta las posiciones en donde el recurso ha transmitido.",
		transmission: "Transmisi\u00F3n",
		TransmissionDescription: "Este reporte retorna el tiempo total de transmisión en un día laboral.",
		EndDateLessToday: "La fecha final debe ser menor que hoy",
		DateRequired: "Faltan campos, la fecha es requerida",
		RangeExceeds: "El rando de fechas excede el maximo de noventa (90) días",
		EndDateGreaterInitDate: "La fecha final debe ser mayor que la fecha inicial",
		EndDateGreaterOrEqualInitDate: "La fecha final debe ser mayor o igual que la fecha inicial",
		DateInitMustBeLessToday: "Para este reporte las fechas deben ser menor  que hoy",
		General: "Reporte General de Recursos",
		Single: "Reporte de Único Recurso",
		Multiple: "Reporte de Múltiples Recursos",
		AlertTextLogin: "Los reportes de tipo general no cecesitan asignaciones de recursos.",
		Generate: "Generar",
		History: "Historial",
		DeleteAllText: "Esta seguro de eliminar todos los recursos?",
		SelectFileTitle: "Generar Reporte",
		SelectFile: "Seleccione el tipo de archivo",
		Error: "Ocurrió un error. Inténtalo de nuevo!",
		ShowFiles: "Ver Archivos",
		FileName: "Nombre del Archivo",
		TotalFiles: "Total Archivos",
		DownloadReports: "Historial de reportes",
		MaxResourcesReached: "Este tipo de reporte no se puede generar para más de 10 recursos",
		ReportType: "Tipo de Reporte",
		ProcessingReport: "Procesasando un reporte",
		HistoricalpositionText:
			"Este reporte es procesado en segundo plano y la plataforma le notificara su estado a traves del modulo de notificaciones en la parte superior",
		ReportProcessFinish:
			"Ahora, puede encontrar el archivo de resultados en el historial de reportes para descargarlo",
		ReportSetDateRange: "Establece un rango de fechas: Para el reporte seleccionado se permite un maximo de",
		ReportSetFileType: "Seleccione el tipo de archivo que desea generar",
		visitpoint: "Puntos de Visita",
		VisitpointReportDescription:
			"Este reporte devuelve la información de los puntos de visita seleccionados, dividiendo la data en archivos separados por tipo de objeto",
		MultipleVisitPoints: "Reporte de Múltiples Puntos de visita",
		resource: "Recursos",
		ResourceReportDescription:
			"Este reporte devuelve la información de los recursos seleccionados, dividiendo la data en archivos separados por tipo de objeto",
		id: "ID",
		report_type: "Tipo de Reporte",
		date_init: "Fecha Inicial",
		date_end: "Fecha Final",
		resource_id: "ID Recurso",
		added_on: "Fecha de Creación",
		update_on: "Actualizado el",
		total_download_file: "Total Archivos Descargados",
		download_file_id: "ID Archivo Descargado",
		sort_by: "Ordenar por",
		sort_by_description:
			"Seleccione el campo(s) por el cual desea ordenar la lista de reportes, teniendo prioridad los campos seleccionados de izquierda a derecha",
		sorting_type: "Tipo de Orden",
		ascendent: "Ascendente",
		descendent: "Descendente",
		filter_by: "Filtrar por",
	},
	Indicators: {
		Indicators: "Indicadores",
		IndicatorList: "Lista Indicadores",
		TitleConfirmIndicatorCreate: "Crear Indicador",
		TextConfirmIndicatorCreate: "El indicador fue creado exitosamente",
		TitleConfirmIndicatorDelete: "Eliminar Indicador",
		TextConfirmIndicatorDelete: "El indicador seleccionado fue eliminado exitosamente",
		TitleConfirmIndicatorUpdate: "Editar Indicador",
		TextConfirmIndicatorUpdate: "El indicador seleccionado fue actualizado exitosamente",
		DeleteIndicator: "¿Estas seguro de eliminar el indicador? Por favor aceptar para continuar.",
		UpdateIndicator: "Editar Indicador",
		CreateIndicator: "Crear Indicador",
		Visualizer: "Visualizador",
		AlertVisualizar: "Visualizar Indicador",
		AlertVisualizarInfo: "Para ver un indicador, haga clic en el elemento de la lista que desee ver.",
		IndicatorNotFound: "No se econtraron indicadores para listar",
		Indicator: "Indicador",
	},
	Communication: {
		Communication: "Comunicaci\u00F3n",
		Message: "Mensaje",
		Messages: "Mensajes",
		NewMessage: "Nuevo Mensaje",
		MessageReply: "Escriba su mensaje de respuesta aquí",
		Seen: "Visto",
		Unseen: "No Visto",
		MarkAs: "Marcar Como",
		Resolved: "Resuelto",
		PendingForResolved: "Pendiente por resolver",
		AlertVisualizarInfo:
			"Para ver mensajes, haga clic en un elemento de la lista de recursos del cual desea ver sus mensajes.",
		NoMessages: "No hay mensajes.",
		NoMessagesText: "El recurso seleccionado no tiene ningún mensaje.",
		DeleteMessages: "Eliminar Mensajes",
		DeleteMessagesText: "¿Estas seguro de eliminar los mensajes seleccionado? Por favor aceptar para continuar.",
		WaitingToResolve: "Pendiente por resolver",
		UnresolvedMessages: "Mensajes por resolver",
	},
	Notification: {
		Notification: "Notificaci\u00F3n",
		Notifications: "Notificaciones",
		DeleteAllNotifications: "Eliminar todas las notificaciones",
		UPLOAD_FILE: "Notificaciones de cargue de archivo",
		DOWNLOAD_FILE: "Notificaciones de descarga de archivo",
		EVENT: "Notificaciones del calendario",
		New: "Nuevas",
		NewNotification: "Nueva Notificaci\u00F3n",
		AppNotifications: "Notificaciones de la Plataforma",
		NEW_EVENT: "NUEVA VISITA PROGRAMADA",
		EVENT_NOT_ASSIGNED: "VISITA NO ASIGNADA",
		RESCHEDULED_EVENT: "VISITA REPROGRAMADA",
		EVENT_IN_PROCESS: "VISITA EN PROCESO",
		EVENT_ENDED: "VISITA FINALIZADA",
		EVENT_CANCELLED: "VISITA CANCELADA",
		EVENT_ON_THE_WAY: "EN CAMINO A VISITA",
		EVENT_DELAYED: "EN DEMORA A VISITA",
		FINALIZED: "PROCESO FINALIZADO",
		LOADED: "ARCHIVO CARGADO",
		PROCESS: "PROCESANDO ARCHIVO",
		DOWNLOAD_FINALIZED: "Descarga Finalizada",
		PANIC_ALARM: "Alerta de pánico",
		PanicAlarmText: "Uno de los recursos en el campo informó una alarma de pánico",
		CheckOut: "Verificar",
	},
	Login: {
		Subtitle: "Bienvenido, inicia sesión para usar la plataforma.",
		Email: "Correo",
		Password: "Contraseña",
		Remember: "Recuérdame",
		ForgotPassword: "Olvido su contraseña?",
		Register: "Registrarse",
		Disabled: "La cuenta de usuario ha sido bloqueada por el administrador.",
		Login: "Iniciar Sesión",
		ValidMessages: {
			Email: "El campo correo electrónico es requerido y debe ser un correo válido",
			Password: "La contraseña es requerida, mínimo 6 caracteres - máximo 18",
			InvalidPassword: "La contraseña es invalida o el usuario no tiene una asignada",
			UserNotFound: "Algo salio mal validando las credendiales",
			TooManyRequests:
				"Se ha deshabilitado temporalmente el acceso a este usuario debido a muchos intentos fallidos de inicio de sesión. Puede restaurarla inmediatamente restableciendo su contraseña o puede intentarlo de nuevo más tarde",
			text: " mínimo 6 carácteres - máximo 18",
			CompanyReachedWorkingDate: "La empresa alcanzó la fecha de trabajo",
			InvalidCode: "Código de autenticación inválido",
		},
		PasswordWasRestored: "La contraseña fue restaurada con éxito",
		PasswordIsNotSecure: "La contraseña no es segura por favor escriba otra",
		EmailDoesNotExist: "El correo electrónico no existe o no tiene un uid asociado",
		PleaseVerifyCode: "Por favor, verifique el código",
		PasswordIsNotsecure: "La contraseña no es segura por favor escriba otra",
		LoginAttemptTitle: "Intento de inicio de sesión",
		LoginAttemptText: "¡Ya estás conectado!",
		LoginWithGoogle: "Iniciar sesión con cuenta Google",
		EnableTwoFactorAuthentication: "Habilitar doble factor de autenticación",
		TwoFactorAuthentication: "Doble factor de autenticación",
		TwoFactorAuthenticationText:
			"Ingrese el código de 6 dígitos que se le envió al correo electronico para continuar con la autenticación",
		ResendAuthCodeEmail: "Si el mensaje con el código de autenticación no ha llegado, puedes solicitar un reenvío.",
		ResendCode: "Reenviar código",
		CodeSent: "Código de verificación enviado",
	},
	RecoverPassword: {
		Title: "Recuperar contraseña",
		Subtitle:
			"Ingrese su dirección de correo electrónico y le enviaremos instrucciones sobre cómo restablecer su contraseña.",
		Email: "Correo",
		ToLogin: "Iniciar Sesión",
	},
	ResetPassword: {
		TitleReset: "Restablecer contraseña",
		TitleCreate: "Crear contraseña",
		Subtitle: "Ingrese su nueva contraseña.",
		VerificationCode: {
			Title: "Codigo de verificación",
			Text1: "Se envió un código de verificación al correo electrónico. si no llega el código,",
			Text2: "envíelo de nuevo",
		},
		Code: "Código",
		YourPassword: "Tu contraseña",
		ConfirmPassword: "Confirmar contraseña",
		ToLogin: "Iniciar Sesión",
		Reset: "Reiniciar",
		ValidPassword1: "El campo de la contraseña debe tener al menos 6 caracteres",
	},
	CompanyForm: {
		nameRequired: "El nombre es requerido",
		addressRequired: "La dirección es requerida",
		phoneRequired: "El teléfono es requerido",
		nitRequired: "El nit de la empresa es requerido",
		date_initRequired: "La fecha inicial es requerida",
		date_endRequired: "La fecha final es requerida",
		contac_personsRequired: "El contacto es requerido",
		cityRequired: "La ciudad es requerida",
		countryRequired: "El pais es requerido",
		descriptionRequired: "La descripción es requerida",
		InvalidFields: "Campos Inválidos",
		ChechInfo: "Verifique la información, si está bien, haga clic en el botón Guardar para finalizar el proceso.",
		ViewCompanyList: "Haga clic aquí para ir a la lista de empresas",
		AdminResource: "Recurso Administrador",
		AdminResourceSuccess: "Recurso administrador creado exitosamente",
		AdminResourceError: "Recurso administrador no fue creado",
		AdminResourceFailed:
			"Algo salió mal durante la creación del Recurso Administrador; Intente crearlo nuevamente desde la lista de empresas.",
		DateInitError: "La fecha inicial no puede ser mayor a la fecha final.",
		CompanyInformation: "Información  de la Empresa",
		Summary: "Resumen",
		Finish: "Finalizar",
		ActivateServiroutes: "Seleccione el recurso administrador para la activación de serviroutes.",
		ActivateSitidadaText1: "Es necesario activar SITIDATA para un correcto funcionamiento de la plataforma",
		ActivateSitidadaText2: "click aquí para agregar la configuración.",
		RequiredConfig: "Configuraciones Requeridas",
		EmailAlreadyExist: "Ya se encuentra un usuario registrado con este correo electrónico.",
		ValidEmail: "Correo electrónico válido",
		ReleationShip: "Relación con puntos de visita",
	},
	ManualData: {
		Required: "Requerida",
		InformationFound: "Información encontrada",
		ErrorsFound: "Errores encontrados en el cargue de información.",
		ErrorsNotFound: "Ningún error encontrado durante el proceso de carga de información.",
		ValidatorRequiredProperty: "Es una propiedad requerida",
		AlreadyRegistered: "Ya registrado(a)",
		DateLessThanCurrentDate: "La fecha debe ser mayor a la fecha actual",
		NotRegistered: "No registrada en el sistema",
		ValidatorAdditionalProperties: "Propiedad adicional no permitida, por favor eliminela",
		TooShortProperties: "Valor de la propiedad esta vacio o el contenido es demasiado corto",
		country: "Pa\u00EDs",
		city: "Ciudad",
		address: "Direcci\u00F3n",
		identification: "Identificaci\u00F3n",
		phone: "Tel\u00E9fono",
		name: "Nombre",
		cx: "CX",
		cy: "CY",
		date: "Fecha",
		ManageError: "Administrar Errores",
		ProcessAgain: "Procesar Nuevamente",
		ProcessAgainText:
			"Procesar nuevamente el archivo; esto intentará crear nuevos registros en el sistema, así que tenga en cuenta que los registros no deben existir.",
		ProcessAgainTextSuccess:
			"Reprocesar el archivo está funcionando en segundo plano, verifique o espere las notificaciones del sistema para conocer el estado del proceso.",
		DownloadFile: "Descargar Archivo",
		Download: "Descargar",
		AddedOn: "Añadido",
		PropertyError: "Error en la propiedad",
		ShowErrors: "Mostrar errores",
		FixErrorsHere: "Corregir errores aquí",
		FixErrorsModule: "Solucionar errores en módulo",
		SaveChanges: "Guardar Cambios",
		ActivityNotRegistered: "Actividad no registrada",
		EditAlertText:
			"Edite la propiedad seleccionada, respete el formato de esta y tenga en cuenta que algunos valores deben existir.",
		Property: "Propiedad",
		ResourceHasNoActivities: "Recurso no tiene ninguna actividad asignada",
		SaveRecordError: "Error guardando el registro",
		DaneCodeNotFound: "Código dane no encontrado",
		DuplicateRecordInExcel: "Registro duplicado en el excel",
		InitHourLessThanCurrentTime: "La hora inial no puede ser menor que la hora actual.",
		ErrorEndHour: "Error en la hora final",
		ErrorInitHour: "Error en la hora inicial",
		ErrorDate: "Error en la fecha",
		CoordinatesCouldBeNotFound: "Coordenadas no pudieron ser encontradas",
		AddressCouldBeNotGeoreferenced: "La dirección no pudo ser georreferenciada",
		TimeDataFormat:
			"El formato no es válido, el formato correcto debe ser similar para fechas AAAA-mm-dd o para horas HH:mm:ss",
		SitidataGeoreverseToken: "El token georeverse de Sitidata api no está habilitado para este pais",
		InvalidValue: "tiene un valor no valido, solo se permite cadena de caracteres",
	},
	Record: {
		ListRecord: "Lista Registro",
		RecordNumber: "Registro Número",
		UpdateRecord: "Actualizar Registro",
		CreateRecord: "Crear Registro",
		DeleteRecord: "Eliminar Registro",
		DeleteRecordConfirmText: "¿Esta seguro de eliminar el registro del sistema?",
		TitleConfirmRecordCreate: "Registro creado",
		TextConfirmRecordCreate: "El registro fue creado exitosamente",
		TitleConfirmRecordDelete: "Registro Eliminado",
		TextConfirmRecordDelete: "El registro seleccionado fue eliminado exitosamente",
		TitleConfirmRecordUpdate: "Registro Actualizado",
		TextConfirmRecordUpdate: "El registro seleccionado fue actualizado exitosamente",
	},
	Routing: {
		Optimization: "Optimización",
		Resource: "Recurso",
		Routing: "Rutear puntos de visita",
		DistanceRoute: "Distancia",
		MinimumRouteTime: "Tiempo de ruta",
		Typology: "Tipología",
		SelectedColumns: "Columnas Seleccionadas",
		DeparturePointOptionsTex: "Seleccione una de las opciones para agregar un punto inicio o un punto de fin",
		DeparturePoint: "Punto de partida",
		StartingPoint: "Punto de inicio",
		FinalPoint: "Punto de fin",
		FromMapTitle: "Seleccione un punto del mapa haciendo clic en la posición deseada o arrastrando el marcador",
		FromMapAlert: "Seleccione un punto del mapa haciendo clic en la posición deseada",
		FromMap: "Habilita la funcion de poder seleccionar un punto desde el mapa haciendo clic donde se desee",
		FromVisitPoint: "Permite asignar el punto desde el listado de puntos visita del sistema",
		FromGroup: "Permite asignar el punto desde el listado de grupos del sistema",
		FromAdditionalFields: "Permite asignar el punto desde los campos adicionales de tipo ubicación de los objetos",
		Point: "Punto",
		NoFoundDefaultPoint:
			"No se encontró un punto de partida por defecto para el recurso, configure uno a través de la opción Agregar Punto",
		ConfigureInitHour: "Establezca una hora inicial para la optimización y pulse en el boton continuar",
		AcceptOptimization:
			"Esto, actualizara todos los eventos del calendario con la información propuesta por la optimización",
		ErrorOptimization:
			"Ocurrio un error durante la optimización, por favor intentelo de nuevo. Si el error persiste comuniquese con el administrador de la plataforma",
		DateLessThanCurrentDate: "La fecha de optimización no puede ser inferior a la fecha actual",
		RescheduledEvents: "Eventos reprogramados",
		RescheduledEventsText: "Los eventos fueron reprogramados exitosamente",
		OverlapEventsWarning:
			"Para evitar solapamiento en el calendario algunas visitas tuvieron fechas de programación para días posteriores, por favor revise las visitas resaltadas",
		SuccessOptimization: {
			TextOne: "Optimización finaliza exitosamente, revise el resultado",
			TextTwo: "haga clic aqu\u00ED",
			TextThree: "o en el bot\u00F3n",
			TextFour: "para aceptar el resultado y actualizar los eventos en el calendario",
		},
		Buttons: {
			Process: "Procesar Ruta",
			Next: "Siguiente",
			Optimize: "Optimizar",
			SeeRoute: "Ver Ruta",
			Validate: "Validar",
			OtherFields: "Añadir a otros campos",
			AddVisitPoint: "Añadir punto de visita",
			EditVisitPoint: "Editar",
			NextResources: "Siguiente, Selección de recursos",
			ExportRoute: "Exportar ruta",
			SeeAllRoutes: "Ver rutas",
			Schedule: "Agendar",
			DeleteRoute: "Eliminar ruta",
		},
		Table: {
			Type: "Tipo",
			Name: "Nombre",
			AddedOn: "Fecha",
			Action: "Acción",
			Actions: "Acciones",
			Longitude: "Longitud",
			Latitude: "Latitud",
			EstimatedTimeArrival: "Tiempo llegada",
			TimeWindowInit: "Hora de inicio",
			TimeWindowEnd: "Hora de fin",
			Cx: "Latitud",
			Cy: "Longitud",
			Demand: "Demanda",
			InitHour: "Hora Inicial",
			EndHour: "Hora Final",
			TimeService: "Tiempo de Servicio",
			Identification: "Identificación",
			Skills: "Habilidades",
			Row: "Fila Excel",
			Column: "Columna Excel",
			Error: "Error",
		},
		Title: {
			ResourceList: "Lista de recursos",
			VisitPointsList: "Lista de puntos de visita",
			SelectFormat: "Seleccione un formato",
			Close: "Cerrar",
			MatchColumn: "Asignación de columnas",
			TableExample: "Muestra de datos del archivo cargado",
			TableExampleText:
				"A continuación se muestra una previsualización de las columnas y la data encontrada en el archivo cargado, esto con el fin de tener valores de referencia para la asignación de equivalencias.",
			ProcessVisitPoints: "Procesar puntos de visita",
			EditVisitPoint: "Editar Punto de Visita",
			VisitPoints: "Puntos de visita",
			VisitPointsLocations: "Ubicaciones Puntos de visita",
			Resources: "Recursos",
			OptimizeByTeam: "Filtrar por equipos",
			SelectResource: "Seleccione los recursos para exportar",
			Errors: "Encontramos errores",
			UploadVisitpoints: "Cargar puntos de visita",
			UploadVisitpointsList: "Lista de archivos cargados",
			ExportFromDataRutas: "Exportar Puntos de Visita Rutify",
			RoutingHistory: "Historial de Ruteo",
			Schedule: "Agendamiento",
			RoutingMode: "Seleccione el tipo de ruteo",
			Basic: "Básico",
			Logistic: "Logístico",
			Selection: "Selección",
			AssignBulkActivity: "Asignar Actividad Masiva",
			AssignActivity: "Asignar actividad a los puntos de visita seleccionados.",
		},
		Map: {
			MapAppearance: "Apariencia del Mapa",
			Types: "Tipo de mapa",
			Styles: "Estilo de mapa",
			ClickToDownload: "Haga clic para descargar",
			ShowMap: "Mostrar mapa",
			HideMap: "Ocultar mapa",
			ExportRoute: {
				Error: "No se pudo exportar la ruta",
				Success: "Ruta exportada con éxito",
			},
			Schedule: {
				OptionalDate: "Fecha (Opcional)",
				ClickToSchedule: "Haga clic para programar",
				Success: "Solicitud de agenda enviada, para verificar usa el calendario de Rutify",
				Error: "Ocurrió un error y no se envió su horario",
			},
			VisitPoints: {
				Drop: "Punto de visita de caída",
				Dropped: "Punto de visita descartado",
				Identifier: "Identificador",
				TimeArrival: "Hora de llegada",
				Deposit: "Depósito",
			},
			DeleteRoute: {
				DeleteRouteAsk: "¿Está seguro de que desea eliminar la ruta actual?",
				Success: "Ruta eliminada con éxito",
			},
		},
		RouteResult: {
			Title: "Resultado de la ruta",
			ResourcesRouted: "Recursos enrutados",
			ResourcesNotRouted: "Recursos no enrutados",
			RoutesTime: "Tiempo mínimo total todas las rutas",
			TotalDistance: "Distancia total",
			VisitPointsRouted: "Puntos de visita enrutados",
			VisitPointsNotRouted: "Puntos de visita no enrutados",
		},
		Messages: {
			upload_placeholder: "Arrastra aquí tu archivo o haz click para cargarlo desde tu computador.",
			MatchColumn:
				"Claves y valores equivalentes a los nombres de columna dados en el archivo a procesar, para enrutamiento.",
			MatchColumnSelectionRouting:
				"Asignación de equivalencias entre columnas encontradas en el archivo y las propiedades requeridas por el proceso de enrutamiento.",
			MatchColumnSelectionRoutingP2:
				"Seleccione a continuación de cada valor requerido por el tipo de cargue seleccionado, la columna correspondiente encontrada en el archivo.",
			MatchColumnSelectionRoutingP3:
				"A través de la opción 𝐚𝐝𝐝 del listado, podemos agregar las columnas como valores adicionales al resultado del proceso de enrutamiento, el resto de columnas se omitirán.",
			MatchColumnSelectionRoutingP4:
				"Una vez termianda la asignación, haga click en el boton 𝐆𝐮𝐚𝐫𝐝𝐚𝐫 para continuar con la selección en el mapa.",
			MatchColumnSelectionRoutingError: "Faltaron las siguientes equivalencias por asignar: ",
			MatchColumnSelectionRoutingErrorEquivalents: "Es necesario asignar las equivalencias de las columnas",
			MatchColumnSelectionRoutingErrorTitle: "Error Equivalencias",
			SelectedColumns:
				"Nombres de columnas que desea conservar y que aparecen en la respuesta de enrutamiento, el resto de campos se omitirán.",
			ErrorMsg: "Por favor corrige los siguientes errores e intenta subir el archivo de nuevo.",
			AlertRoutingHistory:
				'Recuerda que puedes volver a optimizar un ruteo previamente cargado, utilizando la función "optimizar" y seleccionando nuevos recursos.',
			AlertProccessing: "Estamos trabajando para optimizar tu ruteo, te notificaremos cuando este completado.",
			SelectSchedule: "Seleccione sus recursos para agendar",
			DataRutasVisitPointsSelect:
				"Esta es tu lista de puntos de visita en Rutify, para crear un ruteo usando estos puntos, selecciónalos y elige un tipo de ruta",
			AssignEquivalents: "Asignación Equivalencias De Columnas",
		},
	},
	RoutesLegends: {
		ProgramedRoutes: "Rutas Programadas",
		ExecutedRoutes: "Rutas Ejecutadas",
		TotalVisits: "Total Visitas",
		Distance: "Distancia",
		Time: "Tiempo",
		ViewZones: "Ver las zonas asignadas a los recursos.",
		SpeedReached: "Velocidad Alcanzada",
	},
	Statistics: {
		Statistics: "Estadística",
		VisitsStatistics: "Estadísticas de visitas del mes visualizado en el calendario",
	},
	Setting: {
		Setting: "Ajustes",
		NewConfiguration: "Nueva Configuración",
		VisualSetting: "Ajustes Visuales",
		ThemeColor: "Color del Tema",
		NavbarColor: "Color Barra de Navegación",
		ConfirmSave: "¿Desea guardar los cambios aplicados?",
		Saved: "Cambios guardados exitosamente",
		SelectCompany: "Seleccione la empresa a configurar",
		AllowedLogo: "Permitidos archivos JPG y PNG. Con tamaño maximo de 900kB",
		ImageNotAllowed: "Imagen no permitida",
		ChooseImage: "Elegir Imagen",
		UploadImage: "Cargar Imagen",
		DeleteImage: "¿Estás seguro de eliminar la imagen?",
		ImagenUploaded: "La imagen se cargó correctamente",
	},
	OnDemand: {
		OnDemand: "On Demand",
		AssigResource: "Asignar Recurso",
		SearchResources: "Buscar Recursos",
		Automatically: "Automáticamente",
		Manually: "Manual",
		FindResources: "Buscar recursos en un radio de",
		SetRadiusOnMapTitle: "Establecer radio en el mapa.",
		SetRadiusOnMapText: "Ahora puede dibujar el radio de busqueda de recursos desde el mapa.",
		AvailableResources: "Recursos disponibles para la asignaci\u00F3n",
		NoAvailableResources: "Recursos descartados",
		NoAvailableResourcesText:
			"No se encontraron recursos disponibles para la asignación, haga clic en el botón ver recursos descartados para obtener mas información",
		NoAvailableResourcesDateText:
			"No se encontraron recursos disponibles para la asignación, la visita pertenece a días posteriores a la fecha actual, para continuar reasigné la visita a una fecha igual o mayor a la actual",
		AlertVisualizarInfo:
			"Para ver y gestionar una visita, haga clic sobre un elemento de la lista presentada a la derecha.",
		Distance: "Distancia",
		Notify: "Notificar",
		ResourcesWereNotified: "Todos los recursos fueron notificados",
		ResourcesAssigned: "Visita asignada al recurso exitosamente",
		DateAssignedEnded: "La fecha límite para asignar esta visita ya terminó",
		ConfirmAssign: "¿Continuar con la asignaci\u00F3n de la visita al recurso?",
		NoFoundEvents: "No se encontraron eventos por asignar",
		AutomaticAllocation: "Asignación automática de recursos",
		AutomaticAllocationText:
			"Activar la asignación automática de recursos evita que los nuevos eventos estén disponibles para la asignación desde este dashboard",
		AutomaticAllocationTextAlert:
			"Si la asignación automática de recursos se encuentra activa, evitara que los nuevos eventos se muestren en este dashboard",
		Enabled: "Activada",
		Disabled: "Desactivada",
		AvailableResourcesText:
			"Recursos con disponibilidad en fecha y hora de la visita (Agenda, Actividad y Asignación con el punto)",
		AvailableResourcesZone: "en la misma zona del punto",
		AvailableResourcesZoneRelated: "Rescursos asignados a la misma zona del punto de visita",
		AvailableResourcesEvents: "Recursos con un máximo número de visitas asignadas",
		AvailableResourcesLocation: "Buscar recursos teniendo en cuenta las coordenadas de",
		AvailableResourcesLocationTracking: "Transmisión",
		AvailableResourcesLocationTrackingTitle: "Posición actual reportada por los recursos en campo",
		AvailableResourcesLocationDefault: "Localización por defecto",
		AvailableResourcesLocationDefaultTitle:
			"Propiedad de recurso adicional para establecer un punto de ubicación predeterminado",
		SetFilters: "Establecer criterios de búsqueda",
		NotifyOnCreateEnabledWarning:
			"Para activar la asignación automática de recursos, es necesario que en la configuración de ON_DEMAND el valor de notify_on_create sea false",
		DisabledMapBtnTitle:
			"El seguimiento en el mapa estará disponible una vez que el recurso cambie el estado de la visita a en camino",
		TrackingOnTheMap: "Seguir en el mapa",
		ScheduledHour: "Hora programada",
		ExecutedHour: "Hora ejecutada",
		DistanceToPoint: "Distancia aérea hasta el punto",
		ReachedThePoint: "Ha llegado al punto",
		RequestedVisits: "Visitas solicitadas",
		AssignedVisits: "Visitas Asignadas",
		NotAssignedVisits: "Visitas No Asignadas",
		ViewResourceCalendar: "Ver el calendario del recurso",
		AvailabilityFilters: "Filtros de disponibilidad",
		LocationFilters: "Filtros de ubicación",
		SearchResultAlert:
			"Haga clic sobre los marcadores correspondiente a los recursos para ver su información. Si por lo menos, marcó uno de los filtros de ubicación se visualizaran las zonas asignadas al recurso que se cruzan con el punto de visita",
		Free: "Gratuito",
		NotifyAllResources: "Notificar a todos los recursos",
		NotDistance: "Fuera del radio establecido",
		NotAvailability: "No cuenta con disponibilidad en agenda, actividad o asignación con el punto de visita",
		NotLocation: "not location",
		NotEvents: "Supera el número máximo de visitas establecidas",
		NotLocation1: "No tiene transmision activa",
		NotLocation2: "No tiene localizacion por defecto",
		NotRelatedZone: "No tiene ninguna zona relacionada donde esta el punto de visita",
		NotLocationZone: "No esta ubicado en la misma zona del punto de visita",
		DiscardedBy: "Descartado por",
		SendNotify:
			"Notificar recursos, crea una subasta entre todos los recursos disponibles para que acepten o rechacen la visita, ¿desea continuar?",
		SelectDateRange: "Seleccionar Rango de Fechas",
		ChangeDate: "Cambiar Fecha",
		ChangeDateText:
			"Le permite establecer un rango de fechas para ver las visitas no administradas de días posteriores",
		HideVisitListOnSelect: "Ocultar automaticamente la lista de visitas al seleccionar",
		ShowList: "Mostrar lista",
		HideList: "Ocultar lista",
	},
	FormMessages: {
		RequiredName: "El nombre es un campo requerido",
		RequiredLastname: "El apellido es un campo requerido",
		RequiredIdentification: "La identificación es un campo requerido",
		RequiredEmail: "El correo electrónico es un campo requerido",
		InvalidEmail: "El correo electrónico debe tener una estructura valida",
		RequiredUsername: "El username es un campo requerido",
	},
	MassiveAssignment: {
		MassiveAssignment: "Asignación Masiva",
		SelectedResources: "Recursos seleccionados",
		SelectedVisitPoints: "Puntos de visita seleccionados",
		ShowAssignedVisitPointToltip: "Ver puntos de visita actualmente asignados al recurso.",
		SelectVisitPoints: "Seleccionar Puntos de Visita",
		SelectResources: "Seleccionar Recursos",
		MaxSelectedResources: "Seleccione minimo un recurso y maximo cuatro para continuar.",
		MaxSelectedResourcesReached: "Selección máxima de recursos alcanzada",
		MaxSelectedVisitPoints: "Seleccione minimo un punto de visita para continuar.",
		VisitPointsConfirmAssign:
			"¿Continuar con la asignaci\u00F3n de los puntos de visita al los recursos selccionados?",
		VisitPointsAssignationSuccessText: "La asignaci\u00F3n de puntos de visita fue realizada exitosamente.",
		UploadFileNote:
			"Si tiene un archivo de asignaciones masiva anteriores puede cargarlo aqui, de lo contrario continue con la selecci\u00F3n de recursos",
		MassiveAssignmentUploadFile: "Seleccione archivo de asignaci\u00F3n masiva",
		LoadMassiveAssignmentUploadFile: "Cargar archivo para recuperar selecci\u00F3n",
		LoadMassiveAssignmentUploadFileError: "El archivo no tiene un formato valido para cargar la informaci\u00F3n",
		ConfirmAssignText:
			"Marque Guardar, si desea generar un archivo con la información de los puntos de visita seleccionados, el cual permitirá recuperar esta selección en posteriores asignaciones.",
	},
	general: {
		AllFieldsRequired: "Todos los campos son requeridos para continuar",
		MapAppearance: "Apariencia del Mapa",
		MapTypes: "Tipos de Mapas",
		MapStyle: "Estilo de Mapa",
		WelcomeToRutify: "Bienvenido a Rutify",
		LoginDescription: "Inicia sesión y empieza a disfrutar de tu plataforma.",
		Email: "Correo Electrónico",
		Emails: "Correos Electrónicos",
		Remember: "Recordarme",
		RememberPassword: "¿No recuerdas tu contraseña?",
		ForgotPassword: "Restablece tu contraseña aquí",
		Styles: "Estilos",
		VisitPoints: "Puntos de Visita",
		VisitingPointsDescription: "Seleccione los puntos de visita que desea localizar en el mapa.",
		Status: "Estado",
		GpsStatus: "Estado GPS",
		Navigation: "Navegación",
		ClearMap: "Limpiar Mapa",
		SubTitleZonification: "Crear y administrar zonas en el mapa",
		Selectt: "Seleccionar",
		DescriptionResource: "Selecciona los recursos a asignar en el nuevo punto de visita",
		SubTitleObject: "Conoce y administra los estados de tus pedidos",
		SubTitleProperty:
			"Seleccione un esquema para ver las propiedades mínimas que el objeto puede tener o así como también poder agregar nuevas propiedades de este",
		SubTitleResource: "Crear y administrar nuevos recursos y sus distribuciones",
		SubTitleResourceUpdate: "Actualizar recursos y sus distribuciones",
		Image: "Imagen",
		SubtitleVisitPoint: "Selecciona los puntos de visita en el nuevo recurso",
		SubtitleGroups: "Selecciona los grupos a asignar",
		SubtitleGroupsActivity: "Selecciona los grupos a asignar en la nueva actividad",
		SubtitleGroupsIndicator: "Selecciona los grupos a asignar en el nuevo indicador",
		SubtitleResource: "Visualiza y administra nuevos recursos y sus distribuciones",
		SubtitleReassing: "Seleccione el nuevo recurso para reasignar las visitas seleccionadas",
		SubtitleVisitPoint2: "Visualiza y administra los puntos de visita disponibles",
		SubtitleVisitPointUpdate: "Actualiza y administra los puntos de visita",
		SubtitleDetailedInformation: "Información detallada de un",
		SubtitleGroupsList: "Visualiza y administra los grupos disponibles y recursos en cada uno",
		SubtitleGroupsCreate: "Selecciona los recursos a asignar en el nuevo punto de visita",
		SubtitleGroupsUpdate: "Actualizar los recursos asignados en el punto de visita",
		SubtitleAssignedVisits: "Visualiza y administra el seguimiento de las visitas asignadas",
		SubtitleOnDemand: "Crear y administrar las visitas no asignadas en el mapa",
		User: "Usuario",
		Scheduled: "Agendado",
		NotAssigned: "Sin Asignar",
		Rescheduled: "Reprogramado",
		OnTheWay: "En camino",
		InProgress: "En Progreso",
		Finalized: "Finalizado",
		Clear: "Limpiar",
		Account: "Cuenta",
		LocationInformation: "Información de ubicación",
		Visualize: "Visualizar",
		New2: "Nueva",
		Activities: "Actividades",
		Relevant: "pertinentes",
		Batteries: "Baterías",
		Load: "Carga",
		Archive: "Archivo",
		ForgetYourPassword: "¿Olvidaste tu contraseña?",
		BacktoStart: "Volver al Inicio",
		FormActivation: "Activación de Formulario",
		SelectYourFile: "Seleccione su archivo",
		Hour: "Hora",
		Initial: "Inicial",
		End: "Final",
		Of: "de",
		RemoveSelection: "Eliminar Selección",
		NoDataFound: "No se encontraron datos",
		SubtitleActivity: "Visualiza y administra las actividades disponibles",
		SubtitleActivityCreate: "Ingresa los datos pertinentes para la nueva actividad",
		SubtitleActivityUpdate: "Actualizar actividades y sus distribuciones",
		SubtitleAlarmSchedule: "Visualiza y añade",
		SubtitleAlarmSchedule1: "las alarmas de",
		SubtitleAlarmSchedule2: "pertinentes",
		SubtitleAlarmCreate: "Ingresa los datos pertinentes para la nueva alarma",
		SubtitleAlarmUpdate: "Actualiza los datos pertinentes asignados a esta alarma",
		SubtitleUploadFile: "Visualiza y administra los archivos de objeto",
		SubtitleUploadFileCreate: "Ingresa los datos pertinentes para la nueva carga de archivos",
		SubtitleReports: "Genera y descarga reportes de acuerdo al indicador seleccionado",
		SubtitleIndicators: "Selecciona y visualiza los indicadores que deseas analizar",
		SubtitleIndicatorsCreate: "Ingresa los datos pertinentes para el nuevo indicador",
		SubtitleIndicatorsUpdate: "Actualiza los datos pertinentes asignados a este indicador",
		SubtitleCommunication: "Manten comunicación constante con tus recursos",
		SubtitleStatusMobile: "Visualiza y administra los estados para móviles",
		SubtitleStatusMobileCreate: "Ingresa los datos pertinentes para el nuevo estado",
		SubtitleStatusMobileUpdate: "Actualiza los datos pertinentes asignados a este estado",
		SubtitleRadiusCreate: "Ingrese los datos pertinentes para la nueva alarma",
		SubtitleRadiusUpdate: "Actualiza los datos pertinentes asignados a esta alarma",
		SubtitleRol: "Visualiza y administra los roles generados por recurso",
		SubtitleForgetPassword:
			"Ingrese su dirección de correo electrónico. Enviaremos las instrucciones a seguir para poder restablecer tu contraseña.",
		SubtitleCompany: "Visualiza y administra las empresas disponibles",
		SubtitleTypology: "Visualiza y administra la tipología disponible",
		SubtitleConfigCompany: "Visualiza y administra cada configuración de la empresa disponible",
		SubtitleStatus: "Visualiza y administra cada estado disponible",
		SubtitlePermissions: "Visualiza y administra cada permiso disponible",
		SubtitleTypeConfig: "Visualiza y administra cada tipo de configuración disponible",
		SelectAllResources: "Seleccionar todos los recursos",
		SelectAllVisitPoints: "Seleccionar todos los puntos de visita",
		RelationShipDescription:
			"Relación de los recursos contra los puntos de visita : all(relacion todos contra todos, un recurso puede atender cualquier punto de visita ), multi(relacion uno a varios, un punto de visita puede ser atendido por varios recursos ) y mono(relacion uno a uno )",
		Raster: "Trama",
		RasterInformation: "Información de trama",
		MaximumResourceReport: "Seleccione un máximo de tres recursos",
		Geofence: "Geocerca",
		SelectedZonesOnTheMap: "Seleccione un máximo de seis zonas para ver en el mapa",
		NoZonesAssigned: "No hay zonas asignadas a este recurso",
		ZonesAllowedOnTheMap: "El número de zonas permitidas para mostrar en el mapa es seis",
		Return: "Volver",
		SearchResourceBy: "Buscar recurso por",
		NoResultsFoundFor: "No se encontraron resultados para",
		TheRole: "El rol",
		ValidateRoleResource:
			"no permite la relación de puntos de visita, grupos o actividades. Para ello debe seleccionar un rol EXECUTIVE o SUPERVISOR",
		ValidateAssignVisitPointResource: "Se necesita definir el rol del recurso en la informacion requerida",
		NoModule: "La empresa no tiene el módulo o este no está activo",
		Images: "Imágenes",
		Files: "Archivos",
		EmailAlreadyAdded: "Este correo electrónico ya ha sido agregado",
	},
	CreatePasswordVP: {
		SecurityValidation: "Validación de seguridad",
		Question: "Pregunta",
		ToValid: "Para validar",
		QuestionsText: "¿Con cual de las siguientes opciones el usuario tiene relación en el sistema?",
		RequiredAnswer: "Por favor seleccione una opción para continuar",
		NoFoundCode: "Código no encontrado",
		NoFoundCodeText: "Por favor verifica o intenta generar otro código",
		PasswordRestored: "Contraseña restaurada",
		PasswordRestoredText: "La contraseña fue restaurada o creada con éxito",
		ValidationCode: "Código de verificación",
		WriteCode: "Escriba el código recibido por mensaje de text",
		EnableOnDemandUser: "Habilitar Usuario On-Demand",
		SentCode: "Se envió un código de verificación al número de teléfono",
		GoTo: "Ir a",
		CodeExpired: "Código ha Expirado",
		CodeBlocked: "Código Bloqueado",
		CodeExpiredText: "El código ha superado el tiempo de expiración, solicite un nuevo código con el administrador",
		CodeMaximumAttempts:
			"El código ha superado el número máximo de 3 validaciones, solicite un nuevo código con el administrador",
		BadAnswersText:
			"Una o mas de las respuestas de validación seleccionadas no coiciden con los datos del punto de visita, por favor solicite un nuevo código con el administrador para intentarlo nuevamente",
		OnDemandUser: "Usuario On Demand",
		EnableOnDemandUserText:
			"Para habilitar un usuario On Demand a un punto de visita, es necesarion enviar un código de verificación al teléfono móvil que desea vincular al registro",
		CellphoneAlreadyRegister: "El número de celular ya está registrado en esta empresa",
		VisitPointAlreadyRegister: "El punto de visita ya cuenta con usuario registrado en esta empresa",
		CellphoneNoValid: "El número de celular enviado no es un número valido",
	},
	Preferences: {
		Preferences: "Preferencias",
		FilterSearchTitle: "Tipo de busquedas",
		FilterSearchNote: "Sólo funciona cuando la búsqueda es a través de los campos adicionales",
		FilterSearchText:
			"Permite establecer si la búsqueda de puntos de visita o recursos es estrictamente iguales a los criterios especificados o si la búsqueda tiene en cuanta las coincidencias",
		FindExactly: "Buscar por criterio exacto",
		FindCoincidence: "Buscar por coincidencia",
		NumberDays: "Número de dias",
		NotificationNumberDays:
			"Configurar el número de días previos desde los cuales la plataforma cargará y mostrará notificaciones",
		NotificationNumber:
			"Configurar la cantidad máxima de notificaciones que puede mostrarse desde la última notificación recibida",
		DeleteOldNotification:
			"Al iniciar la plataforma, eliminar automáticamente las notificaciones más antiguas a los días previos establecidos anteriormente",
	},
	Chat: {
		Chat: "Chat",
		Members: "Miembros",
		LeaveGroup: "Abandonar el grupo",
		LeaveGroupText: "¿ Está seguro de abandonar el grupo ?",
		ClearHistory: "Eliminar Historial",
		DeleteMemberText: "¿ Está seguro de eliminar del grupo al miembro",
		DeleteChatText: "¿ Está seguro de eliminar el chat ?",
		ViewGroupInfo: "Información del grupo",
		GroupAdded: "Bienvenidos al grupo",
		TypeYourMessage: "Escribe tu mensaje",
		SearchOrStartANewChat: "Buscar o iniciar un nuevo chat",
		SearchContact: "Buscar contacto",
		Contacts: "Contactos",
		StartConversation: "Iniciar Conversación",
		Online: "en linea",
		NoContactFound: "Ningún contacto encontrado",
	},
	Modules: {
		Modules: "Módulos",
		ACTIVITY: "ACTIVIDADES",
		ALARMS: "ALARMAS",
		CALENDAR: "CALENDARIO",
		CHAT: "CHAT",
		COMMUNICATION: "COMUNICACIÓN",
		COMPANY: "EMPRESAS",
		COMPANYCONFIG: "CONFIGURACIÓN DE LA EMPRESA",
		GROUPS: "GRUPOS",
		INDICATORS: "INDICADORES",
		MAP: "MAPA",
		MASSIVE_ASSIGNMENT: "ASIGNACIÓN MASIVA",
		OBJECTS: "OBJETOS",
		ON_DEMAND: "ON DEMAND",
		PERMISSION: "PERMISOS",
		REPORTS: "REPORTES",
		RESOURCES: "RECURSOS",
		ROLE: "ROLES",
		SERVIFORMS: "SERVIFORMS",
		SERVIROUTES: "SERVIROUTES",
		STATUS: "ESTADOS",
		STATUSMOBILE: "ESTADOS PARA MÓVIL",
		STATUSMOBILEMANAGEMENT: "GESTIÓN DE ESTADO MÓVIL",
		TYPE_CONFIG: "TIPO DE CONFIGURACIÓN",
		TYPOLOGY: "TIPOLOGÍA",
		UPLOAD_FILES: "CARGUE DE ARCHIVOS",
		VISIT_POINT: "PUNTOS DE VISITA",
		ZONIFICATION: "ZONIFICACIÓN",
		SESSION_API: "SESION POR API",
	},
	SessionApi: {
		SessionApi: "Sección por API",
		AccessToken: "Token de acceso",
		ExpireDate: "Fecha de expiración",
		ExpireDateError: "La fecha de expiración del token no puede ser mayor a la fecha de operación de la empresa",
		GenerateAccessToken: "Crear nuevo token de acceso por API",
		NotFoundAccessToken: "La empresa no tiene token de accesos por API",
		Copy: "Copiar",
		Copied: "Copiado",
		CopiedText: "Token copiado al portapapeles con éxito",
	},
	DesignConfig: {
		MinimumCharacterLength: "Longitud mínima de caracteres",
		MaximumCharacterLength: "Longitud máxima de caracteres",
		MinimumVal: "Valor mínimo",
		MaximumVal: "Valor máximo",
		Option: "Opción",
		SwitchTitle: "Alternar Activo / Inactivo",
		SelectMinimumOneOption: "Seleccionar mínimo una opción",
		LoadOptions: "Cargar lista de opciones",
		CalendarStatus: "Estados del calendario",
		Composed: "Compuesta",
		AllowValues: "Esta propiedad puede recibir uno de los siguientes valores",
	},
	CompanyModule: {
		MissingServiceTime: "Tiempo de servicio restante",
		Month: "Mes",
		Year: "Año",
		Day: "Día",
		Months: "Meses",
		Years: "Años",
		Days: "Días",
		AllDescription: "Los puntos visita de la plataforma pueden ser atendidos por cualquier recurso ",
		MonoDescription: "El punto de visita solo puede ser atendido por un recurso",
		MultiDescription: "El punto de visita puede ser atendido por varios recursos",
		AdminResourceDescription:
			"El recurso administrador es el primer recurso de la empresa el cual es requerido para agregar configuraciones como SERVIROUTES",
		AccessToken: "Token de acceso",
		GenerateAccessToken: "Generar token de acceso por API",
	},
	EventTracking: {
		EventTracking: "Seguimiento de eventos",
		EventStatusBtn: "Consultar",
		Tracking: "Seguimiento",
		TrackingText:
			"Por favor, introduzca el código único proporcionado para rastrear el progreso, estado y detalles del evento.",
		TrackingCode: "Código de seguimiento Ejemplo: 10000a19t45b1738b77877",
		TrackingCodeRequired: "El código de seguimiento es requerido",
		TrackingCodeInvalid: "El código de seguimiento no es valido",
		EventDetails: "Detalles del evento",
		EventDetailsText:
			"Se mostrará información esencial del estado del evento, asegurando la confidencialidad de los datos sensibles.",
		TrackingHistory: "Historial de Cambios de Estado",
		NextStops: "Próximas Paradas",
		Location: "Ubicación",
		EstimatedTimeArrival: "Hora Estimada de Llegada",
		EstimatedTimeArrivalNextStop: "Hora Estimada de Llegada a la siguiente parada",
		EventNotFound: "Evento no encontrado",
		Message: "Mensaje",
		EventNotFoundText:
			"El evento consultado no se encuentra en nuestros registros. Verifica el código ingresado y vuelve a intentarlo",
		EventScheduleInformation: "Información de programación del evento",
		ScheduleDate: "Fecha de programación",
		ScheduleInitHour: "Hora de inicio programada",
		ScheduleEndHour: "Hora de fin programada",
		Print: "Imprimir",
		Updates: "Actualizaciones",
		AlphaNumeric: "Solo se permiten caracteres alfanuméricos y maximo 22 caracteres",
	},
	Waypoint: {
		Waypoint: "Punto de Parada",
		Waypoints: "Puntos de Parada",
		WaypointText:
			"Un waypoint es un punto de interés que se debe visitar antes de llegar al punto de visita, para realizar una tarea de entrega o recogida",
		WaypointList: "Lista de Paraadas",
		SelectWaypoint: "Seleccionar Punto de Parada",
		SelectWaypointText: "Seleccione un punto de parada para ver su información",
		NoWaypointFound: "No se encontraron puntos de parada",
		NoWaypointFoundText: "No se encontraron puntos de parada en la visita seleccionada",
		WaypointDetails: "Detalles del Punto de Parada",
		WaypointsConfiguration: "Configuración de puntos de parada",
		WaypointConfiguration: "Configuración de Puntos de Parada",
		WaypointConfigurationText:
			"Configuración de los puntos de parada que deben ser atendidos por el recurso antes de llegar al punto de visita",
		Delivery: "Entrega",
		Pickup: "Recogida",
		order: "Orden",
		cx: "Latitud",
		cy: "Longitud",
		job_type: "Tipo de trabajo",
		priority: "Prioridad",
		service_time: "Tiempo de servicio",
		capacity: "Capacidad",
		OrderText: "Orden en el que se debe atender el punto de parada",
		JobTypeText: "Tipo de trabajo a realizar en el punto de parada",
		PriorityText: "Prioridad de atención del punto de parada va de 0 a 10, donde 10 es la prioridad más alta",
		WaypointInformation: "Información del Punto de Parada",
		EnterWaypointInformation: "Ingrese la información del punto de parada para continuar",
		NotWaypointAdded: "No se ha agregado ningún punto de parada",
		AddWaypoints: "Agregar Punto de Parada",
		AddWaypointText:
			"Para agregar un punto de parada, haga clic en la hubicación deseada en el mapa y complete la información solicitada o a través del botón agregar para geo-referenciar una dirección",
		ReorderWaypoints: "Reordenar Puntos de Parada",
		ReorderWaypointsText:
			"Para reordenar los puntos de parada, arrastre y suelte el elemento en el orden deseado sobre la lista",
		OpenWaypointConfiguration: "Abrir configuración de punto de parada",
		CloseWaypointConfiguration: "Cerrar configuración de punto de parada",
		OpenWaypointConfigurationView: "Click para abrir o cerrar la vista de configuración de puntos de parada",
		WaypointConfigurationNotAvailable:
			"La configuración de puntos de parada solo está disponible para la creación de una visita a la vez",
		WaypointConfigurationNotAvailableText:
			"Para configurar puntos de parada, primero debe agregar una visita a la lista de visitas para asignar al recurso",
		WaypointsReordered: "Puntos de parada reordenados con éxito",
		ServiroutesErrorCreate: "Se ha producido un error al procesar los puntos de parada en Serviroutes",
		WaypointsRouteFetched: "Ruta para los puntos de paradad obtenida con éxito",
		RoutingFetchError: "Error al obtener la ruta para los puntos de parada",
		MaxWaypointsReached: "Se ha alcanzado el número máximo de puntos de parada permitidos",
	},
	Follower: {
		Follower: "Seguidor",
		Followers: "Seguidores",
		FollowersText:
			"Los seguidores son los usuarios se son notificados de los cambios en el estado de la visita o evento de un recurso",
		FollowersList: "Lista de Seguidores",
		SelectFollower: "Seleccionar Seguidor",
		SelectFollowerText: "Seleccione un seguidor para ver su información",
		NoFollowerFound: "No se encontraron seguidores",
		NoFollowerFoundText: "No se encontraron seguidores en la visita seleccionada",
		FollowerDetails: "Detalles del Seguidor",
		FollowersConfiguration: "Configuración de seguidores",
		FollowerConfiguration: "Configuración de Seguidores",
		FollowerConfigurationText:
			"Configuración de los seguidores que recibirán notificaciones de las visitas de un recurso",
		FollowBy: "Seguido por",
		FollowersInformation: "Información del Seguidor",
		EnterFollowerInformation: "Ingrese la información del seguidor para continuar",
		NotFollowerAdded: "No se ha agregado ningún seguidor",
		AddFollowers: "Agregar Seguidor",
		AddFollowerText:
			"Para agregar un seguidor, digite un numero de celular o correo electrónico y haga clic en el botón agregar",
		SelectEvent: "Selección de Evento",
		SelectEventText:
			"Elige la visita a la que deseas agregar seguidores. Si accediste desde el calenadrio, la visita se seleccionará automáticamente.",
		SearchEvent: "🔍 Buscar evento...",
		SearchEventText: "Busca un evento por nombre de recurso o identificador de evento",
		SearchEventNotFound: "No se encontraron eventos",
		SelectNotificationChanel: "Canales y Tipos de Notificación",
		SelectNotificationChanelText:
			"Elige a través de que canal deseas recibir las notificaciones de los eventos del recurso, puedes seleccionar uno o varios canales",
		SelectNotificationChanelText2:
			"Elige el estado del evento sobre cual deseas recibir notificaciones, puedes seleccionar uno o varios estados",
		Email: "Correo Electrónico",
		Sms: "Mensaje de Texto (SMS)",
		WhatsApp: "WhatsApp",
		RecipientSettings: "Configuración de Destinatarios",
		RecipientSettingsEmail: "Configuración de Correo Electrónico",
		RecipientSettingsSmsOrWhatsApp: "Configuración de Mensaje de Texto (SMS) o WhatsApp",
		RecipientSettingsText:
			"Ingrese la información de los destinatarios para cada canal de notificación seleccionado",
		RecipientSettingsTextAlertText:
			"Por favor, selecciona al menos un canal de notificación para continuar con la configuración",
		RecipientSettingsEmailText:
			"Ingresa los correos electrónicos a los que se enviarán las notificaciones. Puedes agregar varios, separándolos por comas.",
		RecipientSettingsEmailPlaceholder: "Ejemplo: ejemplo@correo.com, otro@correo.com",
		RecipientSettingsEmailPlaceholderList: "Lista de correos agregados (con opción de eliminar)",
		RecipientSettingsEmailError: "Ingresa al menos un correo electrónico",
		RecipientSettingsEmailErrorInvalid: "Ingresa un correo electrónico válido",
		RecipientSettingsEmailErrorDuplicate: "El correo electrónico ya ha sido agregado",
		RecipientSettingsSmsOrWhatsAppText:
			"Ingresa los números de celular a los que se enviarán notificaciones por SMS o WhatsApp. Recuerda incluir el código de país.",
		RecipientSettingsSmsOrWhatsAppPlaceholder: "+57 3001234567, +57 3107654321",
		RecipientSettingsSmsOrWhatsAppPlaceholderList: "Lista de números agregados (con opción de eliminar)",
		RecipientSettingsSmsOrWhatsAppError: "Ingresa al menos un número de celular",
		RecipientSettingsSmsOrWhatsAppErrorInvalid: "Ingresa un número de celular válido",
		RecipientSettingsSmsOrWhatsAppErrorDuplicate: "El número de celular ya ha sido agregado",
		Template: "Plantilla",
		Templates: "Plantillas",
		TemplateSettings: "Configuración de Plantillas",
		TemplateSettingsText:
			"La platntilla define la estructura y contenido del mensaje de las notificaciones que se enviarán a los seguidores del evento",
		SelectTemplate: "Seleccionar Plantilla",
		SelectTemplateText: "Elige la plantilla que se usará para enviar las notificaciones a los seguidores",
		TemplateText: "Texto de la plantilla",
		PleaseSelectTemplate: "Por favor selecciona una plantilla para ver su estructura y contenido aquí",
		SelectTemplateError: "Selecciona una plantilla para continuar",
		email: "Correo Electrónico",
		cell_phone: "Números de Celular",
		in_event_status: "En estado de evento",
		template_name: "Nombre de la plantilla",
		whatsapp: "WhatsApp",
		sms: "SMS",
		to_email: "Correos Electrónicos",
		event_id: "Identificador de evento",
		email_error:
			"Al menos un correo electrónico es requerido, si el canal de notificación es correo electrónico está seleccionado",
		cell_phone_error:
			"Al menos un número de celular es requerido, si el canal de notificación es mensaje de texto (SMS) o WhatsApp está seleccionado",
		in_event_status_error: "Al menos un estado de evento es requerido",
		template_name_error: "El nombre de la plantilla es requerido",
		event_id_error: "Por favor selecciona una visita para continuar",
		NoEmailsYet: "No se han agregado correos electrónicos",
		NoCellPhonesYet: "No se han agregado números de celular",
		NoEventStatusYet: "No se han seleccionado estados de evento",
		SelectLanguage: "Seleccionar Idioma",
		SelectVisit: "Seleccionar visita",
		SearchVisit: "Buscar visita",
		SearchVisitByDate: "Buscar visita por fecha",
		SetDateRange: "Establecer rango de fechas",
		SearchVisitByDateText:
			"Busca una visita por fecha de inicio o establece un rango de fechas para mas resultados",
		SelectVisitText: "Elige la visita a la que deseas agregar seguidores",
		SearchVisitText: "Busca una visita por nombre de recurso o identificador de visita",
		SearchVisitNotFound: "No se encontraron visitas",
		SelectLanguageText: "Elige el idioma en el que deseas recibir las notificaciones",
		ConfigCompanyRequired:
			"La empresa debe contar con la configuración de {id} para continuar con esta funcionalidad",
		PleaseContactAdmin: "Por favor contacta al administrador de la plataforma para activar esta configuración.",
		alreadyExistToPhoneNumber:
			"La visita ya tiene asignado una notificación para el estado {id} a través de mensaje de texto (SMS) o WhatsApp con el número de celular ",
		alreadyExistToEmail:
			"La visita ya tiene asignado una notificación para el estado {id} a través de correo electrónico para el correo ",
	},
};
